let recaptcha_loaded = false;
let gz_domain = "https://www.giallozafferano.it";
if (lang == "en") {
	gz_domain = "https://www.giallozafferano.com";
} else if (lang == "es") {
	gz_domain = "https://www.giallozafferano.es";
} else if (lang == "pt") {
	gz_domain = "https://www.giallozafferano.com.br";
} else if (lang == "de") {
	gz_domain = "https://www.giallozafferano.de";
} else if (lang == "fr") {
	gz_domain = "https://www.giallozafferano.fr";
} else if (lang == "nl") {
	gz_domain = "https://www.giallozafferano.nl";
} else if (lang == "ja") {
	gz_domain = "https://www.giallozafferano.jp";
}

if (document.querySelectorAll('.mmCarousel').length) {
		mmLoader({
			src: gz_domain + "/js/min/mmCarousel.min.js?cb="+nonce,
			async: true
		});
}

document.addEventListener("DOMContentLoaded", function(event) {
	hashtofrase();
});

function loadRecaptcha() {
	if (document.querySelectorAll('.g-recaptcha').length) {
		if(!recaptcha_loaded) {
			mmLoader({
				src: "https://www.google.com/recaptcha/api.js?onload=onloadCallback&render=explicit",
				async: true
			}).then(() => {
                recaptcha_loaded = true;
            });
		}
	}
}

function hashtofrase() {
    var hash = window.location.href.split("#").pop();
    if (hash) {
        if((hash == 'openlogin' && typeof status1 !== 'undefined' && !status1 && (typeof aInfos === 'undefined' || aInfos["tosUpdate"])) || ((hash == 'openmodalsmart' || hash == 'openlogin') && typeof status1 !== 'undefined' && status1 /* && typeof status2 !== 'undefined' && !status2 */ && (typeof aInfos === 'undefined' || aInfos["tosUpdate"]))) {
			let setModalCheckEmail = new CustomEvent("setModalCheckEmail", {
				detail: {
					action: null,
					source: 'apertura da url',
					non_interaction: true
				}
			});
			document.dispatchEvent(setModalCheckEmail);

			if(hash == 'openlogin'){
				const qs = window.location.search;
				const urlParams = new URLSearchParams(qs);

				if(urlParams.has('err') && urlParams.get('err') == 'wr'){
					eventAnalytics('Errore password','Login',window.location.href,true);
				}
			}
		}

        if(hash == 'openrecoverpwd' && typeof status1 !== 'undefined' && !status1 && (typeof aInfos === 'undefined' || aInfos["tosUpdate"])) {
			let setModalRecoverPwd = new CustomEvent("setModalRecoverPwd", {
				detail: {
					action: null,
					source: 'apertura da url',
					non_interaction: true
				}
			});
			document.dispatchEvent(setModalRecoverPwd);
		}
	}
}

if(status1){
	mmLoader({
		src: "https://www.giallozafferano.it/js/jquery-3.6.0.min.js",
		async: true
	}, "commonChainLogged")
	.then(element => mmLoader({
		src: "https://www.giallozafferano.it/js/min/common-logged.min.js?cb=" + nonce,
		async: true
	}, "commonChainLogged"));
} else {
    if(lang == "it") {
		for (const el of document.querySelectorAll('.gz-add-preferiti')) {
			el.classList.add('gz-add-preferiti-processed');
		}
	
		document.addEventListener('click', (event) => {
			if(event.target.closest('.gz-add-preferiti')){
				event.preventDefault();
				event.stopPropagation();

				// Preserve "add to ricettario" intent across login.
				try {
					const btn = event.target.closest('.gz-add-preferiti');
					const recipeId = btn && btn.dataset ? btn.dataset.recipeid : null;
					if (recipeId) {
						localStorage.setItem('gz_pending_action', JSON.stringify({
							action: 'ricettari_add',
							recipe_id: recipeId,
							ts: Date.now()
						}));
						setCookieCommon('gz_reg_from_preferiti', '1', {
							"domain" : '.giallozafferano.it',
							"expires": new Date(Math.floor(Date.now()+15*60000)).toUTCString(),
							"path" : "/",
							"SameSite" : "Lax"
						});
					}
				} catch (e) { }

				if(event.target.closest('.md-engageLayer-container')){
					eventAnalytics('Click su correlato engage layer', 'Interazione', 'Click preferito');
				} else if(event.target.closest('.gz-button-leaf')){
					eventAnalytics('Ricettario', 'Interazione', 'Click bottone ' + event.target.closest('.gz-button-leaf').dataset.shareposition);
				} else {
					var recipe_name = event.target.closest('.gz-card').querySelector('.gz-title').textContent;
					eventAnalytics('Ricettario - Aggiunta da thumb', 'Interazione', `${recipe_name} - ${window.location.href}`);
				}
				
				// Keep using setModalCheckEmail (login context), but force redirect URL unchanged.
				let setModalCheckEmail = new CustomEvent("setModalCheckEmail", {
					detail: {
						action: "ricettari",
						modal: true,
						redirect_url: window.location.href
					}
				});
				document.dispatchEvent(setModalCheckEmail);
				return;
			}
		}, false);
	}
}

var pdown_desktop_data,
	isAnimationAllowed = true;

function isStripAnimationAllowed(e) {
	document.addEventListener("child_NoBmVideoAdv", function() {
		console.log('[push FE] NoBmVideoAdv: '+parseInt(performance.now() - startPageTimes.performanceNow));
	});

	document.addEventListener("child_BmVideoPlay", function() {
		console.log('[push FE] BmVideoPlay: '+parseInt(performance.now() - startPageTimes.performanceNow));
	});

	document.addEventListener("child_BmVideoAdv", function() {
		console.log('[push FE] BmVideoAdv: '+parseInt(performance.now() - startPageTimes.performanceNow));
	});

	return true;
}

function injectAudioSentinel() {
	return new Promise((resolve, reject)=>{
		const videoSentinel = window.top.document.createElement('video');
		videoSentinel.src =  gz_domain + "/style/video_sentinel/sentinel.mp4"
		videoSentinel.controls = true;
		videoSentinel.muted = false;
		videoSentinel.playsInline = true;
		videoSentinel.volume = 0.001;
		videoSentinel.setAttribute("style", "position:fixed;bottom:-200px;z-index:-1;");
		window.top.document.body.appendChild(videoSentinel);
		console.log('[Check AudioOn] Video sentinella caricato');
		resolve(checkSentinelResponse(videoSentinel));
	});
}
function checkSentinelResponse(elem){
	let checkAudioDone = new CustomEvent("checkAudioDone");
	return new Promise((resolve, reject) => {
		let interrogateSentinel = elem.play();
		if (interrogateSentinel !== undefined){
			interrogateSentinel.then(function () {
				if(lang == 'it' && !isIOS) {
					resolve(audioModeOnSentinel = true);
					console.log('[Check AudioOn] Invio evento checkAudioDone. (Audio on consentito)');
					console.log('[Check AudioOn] AudioOn permesso!', 'Valore audioModeOnSentinel:',audioModeOnSentinel);
				} else  {
					resolve(audioModeOnSentinel = false);
					console.log('[Check AudioOn] Audio on NON consentito' + (isIOS ? ' (iOS)' : ''));
				}
				
				//L'evento viene ascoltato nel template ricetta.tpl
				window.dispatchEvent(checkAudioDone);
			}).catch(function (error) {
				resolve(); // Non modifico audioModeOnSentinel. È false di default
				console.log('[Check AudioOn] Invio evento checkAudioDone. (Audio on NON consentito)');
				//L'evento viene ascoltato nel template ricetta.tpl
				window.dispatchEvent(checkAudioDone);
				console.log('[Check AudioOn]', error)
			})
		}
	})
}

/**
   * Costruisce i parametri custom per le richieste pubblicitarie.
   * Comportamento allineato all'implementazione originale: tutti i parametri
   * sono sempre presenti (anche con valore vuoto) per compatibilità con il server.
   * @param {Object} options - Opzioni aggiuntive per i parametri
   * @param {string} options.pos - Posizione del video (default: "vod")
   * @returns {string} - Stringa di query con tutti i parametri
   */
function buildAdRequestCustomParams(options = {}) {
    const { pos = "vod" } = options;

    const permutiveData = JSON.parse(localStorage.getItem('_pfws') || '[]');
    const permutive = permutiveData.join(',');
    const prmtvwid = (window.permutive && window.permutive.config && window.permutive.config.workspaceId) || '';
    const prmtvvid = (window.permutive && window.permutive.config && window.permutive.config.viewId) || '';
    const puid = localStorage.getItem('permutive-id') || '';
    const ame_publisher_id = typeof getGaClientId === 'function' ? getGaClientId() : '';

    return [
      `permutive=${permutive}`,
      `prmtvwid=${prmtvwid}`,
      `prmtvvid=${prmtvvid}`,
      `puid=${puid}`,
      'tad=0',
      `ptime=${Date.now().toString()}`,
      'embed=true',
      `pos=${pos}`,
      `ame_publisher_id=${ame_publisher_id}`
    ].join('&');
  }

(function () {
	let pushFrequencyCap = {
		mobile: 24, //Impostare il valore in ORE
		desktop: null, //Impostare null se non utilizzato
	}
	let checkPushdownCap = isMobile ? getCookieCommon('pushDownCapMobile') : getCookieCommon('pushDownCapDesktop');

	console.log(`%c[Push-diretta] Il valore di pushFrequencyCap ${isMobile ? 'Mobile' : 'Desktop'} risulta settato a: ${isMobile ? pushFrequencyCap.mobile : pushFrequencyCap.desktop }`,'background-color: #55FFFF;padding:5px;color:black;');
	
	function initPushdown() {
		// Parametro facilmente modificabile per la percentuale di IMA (es: 0.15 = 15%)
		//const imaPercentage = 0; // Modifica qui per cambiare la percentuale di IMA

		// Funzione randomica per scegliere l'adServer SOLO per lang 'it'
		//let agency = (lang == 'it') ? (Math.random() < imaPercentage ? 'adk' : 'freewheel') : 'mdm';
		//let advFallbacks = (lang == 'it') ? (adServer === 'freewheel') : false;
		//let injectSecondPreroll;

		// Se adServer è IMA e lang è 'it', setta i parametri richiesti
		//if (lang == 'it' && adServer === 'ima') {
		//	advFallbacks = false;
		//	injectSecondPreroll = { enabled: false, preload: 5 };
		//}

		// Log per sapere quale adServer è stato impostato
		//console.log(`[Push-diretta] adServer selezionato: ${agency} (lang: ${lang})`);

		// PushConfObj è l'oggetto che contiene tutti i parametri con i quali andremo a inizializzare la PUSH
		const pushConfObj = {
			adServer: 'ima',
			agency: 'mdm',
			AudicomTracker: ['www.giallozafferano.it', 'ricette.giallozafferano.it'].includes(document.location.hostname), // GZ-2595: acceso solo su www. e ricette.giallozafferano.it
			adRequestCustomParams: buildAdRequestCustomParams(),
			agencyOptions: { 
				mdm: {
				  iasMonitoring:{enabled: true, id: '929824'},
				  amazonTam: {
					enabled:false,
					pubID:'5123', 
					sellerData:{
					  asi:'adkaora.com', 
					  sid:'1111', 
					  hp:1
					}
				  },
				  adRequestCustomParams: buildAdRequestCustomParams(),
			  }, 
				adk: {
				  iasMonitoring:{
					enabled: false, id: '929824',
				  },
				  amazonTam: {
					enabled:false,
					pubID:'5123', 
					sellerData:{
					  asi:'adkaora.com', 
					  sid:'1111', 
					  hp:1
					}
				  }
				} 
			  },
			ajaxUrl: "https://ptp.stbm.it/pushdown/pager-pushdown-v-5-data-2026.php",
			advFallbacks: (lang == 'it') ? true : false,
			closeFlyingAfter: 7000,
			flyMode: "fade",
			audioModeOn: audioModeOnSentinel && !isIOS,
			targetElementId,
			type: "flyfirst",
			website,
			eventListener: (ptpEvent) => {
				if (ptpEvent === 'preroll_started') {
					/*if (AVPushRunningInstances[0].opt.adServer === 'ima') {
						gtag("event", "preroll_tracking", {
							event_category: 'preroll_tracking',
							event_action: 'preroll_started',
							event_label: document.location.href,
							non_interaction: true
						});
						console.log(`%c[Preroll-Tracking] ${ptpEvent}`, 'background-color: #4CAF50; color: white; padding: 2px 5px; border-radius: 3px;');
					};*/
					if (isMobile && typeof pushFrequencyCap.mobile == "number" && (typeof checkPushdownCap == null || checkPushdownCap === '')) {
						console.log("%c[Push-diretta] Il preroll è stato erogato setto il cookie pushDownCapMobile.", 'background-color: #FFFF55;padding:5px;color:black;');
						setCookiePushdown('pushDownCapMobile', 'enabled', pushFrequencyCap.mobile);
					}
					if (!isMobile && typeof pushFrequencyCap.desktop == "number" && (typeof checkPushdownCap == null || checkPushdownCap === '')) {
						console.log("%c[Push-diretta] Il preroll è stato erogato setto il cookie pushDownCapDesktop.", 'background-color: #FFFF55;padding:5px;color:black;');
						setCookiePushdown('pushDownCapDesktop', 'enabled', pushFrequencyCap.desktop);
					}
				}
				/*if (ptpEvent === 'preroll_completed') {
					if (AVPushRunningInstances[0].opt.adServer === 'ima') {
						gtag("event", "preroll_tracking", {
							event_category: 'preroll_tracking',
							event_action: 'preroll_completed',
							event_label: document.location.href,
							non_interaction: true
						});
					};
					console.log(`%c[Preroll-Tracking] ${ptpEvent}`, 'background-color: #4CAF50; color: white; padding: 2px 5px; border-radius: 3px;');
				}*/
			}
		};

		// Aggiungi tag solo se adServer è 'ima' e lang è 'it'
		//if (adServer === 'ima' && lang === 'it') {
		//	pushConfObj.tag = '/21625262017,22676954050/mondadori/giallozafferano.it/preroll_pushdown';
		//}

		// aggiungo TAM solo per lang 'it'
		if (lang == 'it') {
			pushConfObj.amazonTam = {
				enabled: true,
				pubID: '5123',
				sellerData: {
					asi: 'adkaora.com',
					sid: '1111',
					hp: 1
				}
			}
			if (!isMobile) {
				// Se adServer è IMA, injectSecondPreroll è già stato settato sopra
				/*if (adServer === 'freewheel' && lang == 'it') {
					pushConfObj['injectSecondPreroll'] = { enabled: true, preload: 5 };
				} else if (adServer === 'ima') {
					pushConfObj['injectSecondPreroll'] =  { enabled: false, preload: 5 };
				}*/
				pushConfObj['fwPauseOnVisibilityChange'] = false;
				pushConfObj['imaForcePlayOnVisibilityChange'] = true;
			}
		}
	
		//Facciamo partire la chiamata a PTP per il caricamento di tutte le risorse del player
		(function (a, l, t, e, r) {
			a[e] = a[e] || function (s) { (a[e].run = a[e].run || []).push(s) };
			let g, z = l.getElementsByTagName(t)[0];
			if (l.getElementById(e)) { return; }
			g = l.createElement(t); g.id = e; g.src = r; g.async = 1;
			z.parentNode.insertBefore(g, z);
		}(window, document, 'script', 'AVPushLoader', "https://ptp.stbm.it/pushdown/loader/av/pushdown-loader-mdm-test.js"));
	
		console.log("[Push-diretta] Parametri di Configurazione:", pushConfObj);
		//Avviamo la Pushdown!
		AVPushLoader(pushConfObj);
		console.log("%c[Push-diretta] Push inizializzata.", 'background-color: #55FF55;padding:5px;color:black;');
	}

	/*if (!hidePushdown && showPushDown && (typeof checkPushdownCap == null || checkPushdownCap === '')) {
		postTcfReady(initPushdown);
		console.log(`%c[Push-diretta] Controllo showPushDown: ${showPushDown} | siamo su ${isMobile ? 'Mobile' : 'Desktop'} e il cookie pushFrequencyCap NON è ancora stato salvato nel browser. Possiamo erogare!`, 'background-color: #55FF55;padding:5px;color:black;');
	} else {
		console.log(`%c[Push-diretta] Controllo showPushDown: ${showPushDown}. Valore cookie: ${checkPushdownCap || 'Disabled'}. Non possiamo erogare!`,'background-color: #FF5555;padding:5px;color:black;');
	}

	* injectAudioSentinel crea un video fuori dalla viewport.
	* Prova a farlo partire con audio bassissimo.
	* Se si ottiene una promise l'audio on è consentito e la VAR "audioModeOnSentinel" viene impostata a true.
	* Se la variabile audioModeOnSentinel è true usiamo le api del player per impostare un volume al preroll.
	* Se la variabile audioModeOnSentinel è true PTP passa nella chiamata le nuove tag che ci ha fornito mediamond.
	*/
	const startPushDelay = () => {
		const delay = /Android/i.test(navigator.userAgent) || /(iPad|iPhone|iPod)/i.test(navigator.userAgent)
			? 5000
			: 10000;
		setTimeout(()=>{
			initPushdown();
			console.log(`%c[Push-diretta] Controllo showPushDown: ${showPushDown} | siamo su ${isMobile ? 'Mobile' : 'Desktop'} e il cookie pushFrequencyCap NON è ancora stato salvato nel browser. Possiamo erogare!`, 'background-color: #55FF55;padding:5px;color:black;');
		},delay);
	}

	// Esposti per il flusso no-consent (ADVNoConsentFlow) — stesso stack IMA e stessi delay/guard
	window.initPushdown = initPushdown;
	window.startPushDelay = startPushDelay;
	window.canServePushdown = function canServePushdown() {
		return !hidePushdown && showPushDown && (typeof checkPushdownCap == null || checkPushdownCap === '');
	};

	function pushChainStarter(){ 
		let audioFrequencyCap = 12;
		let audioCheckCap = getCookieCommon('audioCap');
		injectAudioSentinel().then(function () {
			if (!hidePushdown && showPushDown && (typeof checkPushdownCap == null || checkPushdownCap === '')) {
				postTcfReady(startPushDelay);
			} else {
				console.log(`%c[Push-diretta] Controllo showPushDown: ${showPushDown}. Valore cookie: ${checkPushdownCap || 'Disabled'}. Non possiamo erogare!`,'background-color: #FF5555;padding:5px;color:black;');
			}
		}).then(function () {
			if (audioModeOnSentinel && !isIOS){
				window.addEventListener("preroll_started", function(event) {
					console.log('[Check AudioOn] preroll_started');
					setTimeout(function () {
							if (isIOS) {
								console.log('[Check AudioOn] iOS: preroll muted, no setVolume');
								return;
							}

							// audio on solo se la chat AI non è aperta
							const chatAiAssistant = document.getElementById('ai-assist');
							if (chatAiAssistant && chatAiAssistant.classList.contains('minimized')){
								console.log('[Check AudioOn] Chat AI chiusa: tengo abilitato audio on');
								if (!isMobile && AVPushRunningInstances[0].opt.mode !== 'content' && (typeof audioCheckCap == null || audioCheckCap === '')){
									AVPushRunningInstances[event.detail.instance].api.setVolume(0.05);
									///////////////////////////Solo per le pushdown desktop impostiamo un CAP per l'audio_on di 12 ore
									setCookiePushdown('audioCap','enabled', audioFrequencyCap);
									console.log('[Check AudioOn] Setto il cap audio');
								} else if (!isMobile && AVPushRunningInstances[event.detail.instance].opt.mode !== 'content' && audioCheckCap === 'enabled'){
									console.log('[Check AudioOn] Cap audio rilevato non imposto audio');
								} else {
									AVPushRunningInstances[event.detail.instance].api.setVolume(0.05);
									console.log('[Check AudioOn] Siamo su mobile o è in esecuzione un video content. Imposto audio on');
								}

								window.addEventListener("openModalAI", () => {
									console.log('[Check AudioOn] evento chat aperta, setto volume a 0');
									AVPushRunningInstances[0].api.setVolume(0);
								});
							}else{
								console.log('[Check AudioOn] Chat AI aperta: no audio on');
							}
						},200)
					});
			}
		})
	}

	postTcfReady(pushChainStarter);
})();
/***************************************** FINE configurazioni push*/

/* Su IT l'intro e' gestita dal componente <md-intro> (GZ-2564): questo blocco resta solo per EN */
if(!hideIntro && !window.MD_INTRO_COMPONENT) {
	(function () {
		/* [giallozafferano] Mediamond-first, fallback AdK se empty — startIntro()
		 * Cap/frequency invariati: 1 intro ogni 6h (limit 1, frequencyHours 6).
		 * Cookie introCap: valore numerico incrementale via getCookieCommon/setCookiePushdown (scadenza in ore),
		 * dominio .giallozafferano.it (nessun getSecondLevelDomain su GZ).
		 * startAdkIntro e' definito nel footer adv-ecosystem-it (IT-only) e invocato con guard typeof. */
		window.INTRO_CAP_CONFIG = {
			enabled: true,
			frequencyHours: 0.25, // 15 minuti
			limit: 1,
			cookieDomain: '.giallozafferano.it'
		};

		window.incrementIntroCap = function () {
			if (!window.INTRO_CAP_CONFIG.enabled) {
				return;
			}
			const current = Number(getCookieCommon('introCap')) || 0;
			setCookiePushdown('introCap', current + 1, window.INTRO_CAP_CONFIG.frequencyHours, window.INTRO_CAP_CONFIG.cookieDomain);
		};

		window.startIntro = function startIntro() {
			if (window.__ameAdkIntroDelivered || window.__ameMmIntroStarted) {
				return;
			}
			const introCheckCap = Number(getCookieCommon('introCap')) || 0;
			const introCapLimit = window.INTRO_CAP_CONFIG.limit;
			if (window.INTRO_CAP_CONFIG.enabled && introCheckCap >= introCapLimit) {
				console.log(`%c[Load Intro] introCheckCap: ${introCheckCap}, massimi tentativi: ${introCapLimit}`, 'background-color: #FFFF55;padding:5px;');
				console.log(`%c[Load Intro] Il cookie introCap risulta settato e i massimi tentativi sono stati raggiunti. Non possiamo erogare la intro.`, 'background-color: #FF5555;padding:5px;');
				return;
			}
			window.__ameMmIntroStarted = true;

			window.googletag = window.googletag || {};
			googletag.cmd = googletag.cmd || [];
			googletag.cmd.push(function () {
				if (window.INTRO_CAP_CONFIG.enabled) {
					console.log(`%c[Load Intro] introCheckCap: ${introCheckCap}, massimi tentativi: ${introCapLimit}`, 'background-color: #FFFF55;padding:5px;');
					console.log(`%c[Load Intro] Cookie non settato o limite non raggiunto. Procedo con la intro.`, 'background-color: #55FF55;padding:5px;');
				} else {
					console.log(`%c[Load Intro] Cap/frequency disabilitati. Procedo con la intro.`, 'background-color: #55FF55;padding:5px;');
				}

				googletag.pubads().addEventListener('slotRenderEnded', function (event) {
					const slotId = event.slot.getSlotElementId();
					// Mediamond empty -> fallback AdK
					if (slotId === 'adv-gpt-outofpage' && event.isEmpty === true) {
						if (!window.__ameMmEmptyHandled && !window.__ameAdkIntroStarted && !window.__ameAdkIntroDelivered) {
							window.__ameMmEmptyHandled = true;
							if (typeof window.startAdkIntro === 'function') {
								window.startAdkIntro();
							}
						}
						return;
					}
					// Mediamond erogata (size [1,1]) -> incremento cap
					if ((slotId === 'adv-gpt-outofpage' && event.size && !event.isEmpty) && (event.size[0] === 1 && event.size[1] === 1)) {
						if (window.INTRO_CAP_CONFIG.enabled) {
							if (typeof window.incrementIntroCap === 'function') {
								window.incrementIntroCap();
							}
							console.log(`%c[Load Intro] Intro erogata. Setto il cookie.`, 'background-color: #FFFF55;padding:5px;');
						} else {
							console.log(`%c[Load Intro] Intro erogata (cap/frequency disabilitati).`, 'background-color: #FFFF55;padding:5px;');
						}
					}
				});
				if (typeof initIntro === "function") {
					console.log(`%c[Load Intro] Intro Chiamata.`, 'background-color: #55FF55;padding:5px;');
					initIntro();
				} else {
					console.log(`%c[Load Intro] La funzione initIntro non risulta dichiarata. Probabile race condition con file mediamond.`, 'background-color: #FF5555;padding:5px;');
				}
			});
		};

		window.addEventListener('gptHandlerLoaded', function () {
			if (window.__ameIntroCanStartHandled) {
				return;
			}
			window.__ameIntroCanStartHandled = true;
			postTcfReady(window.startIntro);
		});
	})();
}
/***************************************** FINE configurazioni intro*/

function footerlinks(page,type) {
	window.open(page,type,'top=150, left=150, width=500,height=600 ,toolbar=no, location=no,status=no,menubar=no,scrollbars=yes,resizable=no');
}	

function doSubmit(ev){
    ev.preventDefault();
    handleSearch.goSearch();
}

/* utility methods */
/* event_name opzionale: default = event_category (retrocompatibile). Passarlo per usare un nome evento GA distinto dalla category. */
function eventAnalytics(event_action, event_category, event_label, non_interaction = false, value = null, event_name = event_category) {
	if(value) {
		gtag("event", event_name, {
			event_category,
			event_action,
			event_label,
			value,
			non_interaction
		});
	} else {
		gtag("event", event_name, {
			event_category,
			event_action,
			event_label,
			non_interaction
		});
	}
}


(handleSearch = () => {
    var me = handleSearch;

    me.init = function(){
		me.querystring = "";
		me.searchUrl = "https://www.giallozafferano.it/ricerca-ricette/";
		if (lang == "en") {
			me.searchUrl = "https://www.giallozafferano.com/recipes-search/";
		} else if (lang == "es") {
			me.searchUrl = "https://www.giallozafferano.es/buscar-recetas/";
		} else if (lang == "pt") {
			me.searchUrl = "https://www.giallozafferano.com.br/pesquisa-receitas/";
		} else if (lang == "de") {
			me.searchUrl = "https://www.giallozafferano.de/rezepte-suchen/";
		} else if (lang == "fr") {
			me.searchUrl = "https://www.giallozafferano.fr/recherche-recettes/";
		} else if (lang == "nl") {
			me.searchUrl = "https://www.giallozafferano.nl/zoek-recepten/";
		}
    };

    me.goSearch = function(){
        var qs = document.getElementById('gz-header-search-input').value;
        if(qs != ""){
            qs = qs.trim();
			me.querystring = me.cleanSearchField(qs);

			document.location.href = me.searchUrl + me.querystring + '/';

			me.sendTrackingTikTok = function () {
				ttq.track('Search', {
					"query": me.querystring // string. The word or phrase used to search. Example: "SAVE10COUPON".
				});
			}
			if(typeof ttq !== 'undefined') {
				postTcfReady(me.sendTrackingTikTok);
			}
            return false;

        }
    };

    me.cleanSearchField = function(qs){
        qs = qs.toLowerCase();
        if(qs.indexOf('?') != -1) qs = qs.substring(0, qs.indexOf('?'));
        qs = qs.replace(/</g,"&lt;").replace(/>/g,"&gt;");
        qs = qs.replace(/&nbsp;/g, "+");
        qs = qs.replace(/ /g, "+");
        qs = qs.replace(/\-/g, "+");
        qs = qs.replace(/_/g, "+");
        qs = qs.replace(/%C2%A0/g, "+");
        qs = qs.replace(/%20/g, "+");
        qs = qs.replace(/http:\/\//g, "");
        qs = qs.replace(/https:\/\//g, "");
        qs = qs.replace(/\//g, "+");
        if(qs.charAt(0) == '+') qs = qs.substring(1);
        if(qs.charAt(qs.length-1) == '+') qs = qs.substring(0, qs.length - 1);
        // qs = encodeURIComponent(qs);
        return qs;
	};
	
	me.init();
})();

(elevatorAme = function(){
	var me = elevatorAme;
	me.sogliaTop = (lang == 'it') ? 85 : 125; //impostazione margine superiore

	if(sw<480) return false;

	try {
		me.target = document.querySelector('.gz-cabin-elevator');
		if(me.target == null) throw '[Ame Elevator] .gz-cabin-elevator non trovato';
	} catch(e) {
		//console.error(e);
		return false;
	}

	try {
		me.wrapperTarget = document.querySelector('.gz-cabin-elevator-wrapper');
		if(me.wrapperTarget == null) throw '[Ame Elevator] .gz-cabin-elevator-wrapper non trovato';
	} catch(e) {
		//console.error(e);
		return false;
	}

	try {
		me.elevatorAmeBase = document.querySelector('.gz-elevator-ame-base');
		if(me.elevatorAmeBase == null) throw '[Ame Elevator] .gz-elevator-ame-base non trovato';
	} catch(e) {
		//console.error(e);
		return false;
	}
	console.log('Init ElevatorAme');
	me.firstContainer = me.wrapperTarget.parentNode;
	me.wrapperTarget.style.top = me.sogliaTop+'px';
	me.targetST = me.target.scrollTop;
	me.cabinElevatorObstacles = document.querySelectorAll('.gz-cabin-elevator-obstacle');
	me.cabinElevatorObstaclesLength = me.cabinElevatorObstacles.length;

	me.isCollide = function(a, b)  {
		var aRect = a.getBoundingClientRect();
		var bRect = b.getBoundingClientRect();

		return !(
			((aRect.top + aRect.height) < (bRect.top) - me.sogliaTop) ||
			(aRect.top > (bRect.top + bRect.height)) ||
			((aRect.left + aRect.width) < bRect.left) ||
			(aRect.left > (bRect.left + bRect.width))
		);
	}

	// scrive lo stile solo se cambia, per non invalidare il layout a ogni frame di scroll
	me.setStyle = function(el, prop, value) {
		if(el.style[prop] !== value) {
			el.style[prop] = value;
		}
	}

	me.checkPosition = function () {
		me.wScrollTop = window.pageYOffset || document.documentElement.scrollTop;
		me.targetRect = me.target.getBoundingClientRect();
		me.firstContainerOT =  me.firstContainer.getBoundingClientRect().top;
		me.targetH = me.target.offsetHeight;
		me.setStyle(me.wrapperTarget, 'height', me.targetH+'px');

		//gestion gancio e sgancio in top
		if(me.firstContainerOT <= me.sogliaTop  && !me.wrapperTarget.classList.contains('gz-elevator-ame-fixed')) {
			me.wrapperTarget.classList.add('gz-elevator-ame-fixed');
		} else if (me.firstContainerOT > me.sogliaTop && me.wrapperTarget.classList.contains('gz-elevator-ame-fixed')) {
			me.wrapperTarget.classList.remove('gz-elevator-ame-fixed');
		}

		//verifichiamo se cabin è in collision
		me.toShow = 1;
		for(i=0;i<me.cabinElevatorObstaclesLength;i++) {
			if(me.isCollide(me.wrapperTarget, me.cabinElevatorObstacles[i])) {
				me.activeObstacleH = me.cabinElevatorObstacles[i].offsetHeight;
				me.rectObstacle = me.cabinElevatorObstacles[i].getBoundingClientRect();
				me.toShow = 0;
			}
		}

		// letture prima delle scritture: top della cabina non sposta wrapper e base
		me.rectWrapper = me.wrapperTarget.getBoundingClientRect();
		me.elevatorAmeBaseRect = me.elevatorAmeBase.getBoundingClientRect();

		if(me.toShow == 0) {
			//se è in collision
			me.targetTop = me.sogliaTop + me.rectObstacle.top+me.activeObstacleH+'px';
		} else { //se non è in collision
			me.targetTop = me.sogliaTop+'px';
		}

		//arrivato in fondo
		if(me.isCollide(me.wrapperTarget, me.elevatorAmeBase) || me.rectWrapper.top > me.elevatorAmeBaseRect.top ) {
			me.targetTop = (me.elevatorAmeBaseRect.top - me.targetH-me.sogliaTop)+'px';
		}
		me.setStyle(me.target, 'top', me.targetTop);

		//se siamo arrivati a fine corsa
		if(me.elevatorAmeBaseRect.top - me.targetH < 0 || me.isCollide(me.target,me.elevatorAmeBase)) {
			if(!me.target.classList.contains('gz-cabin-elevator-hide')) {
				me.target.classList.add('gz-cabin-elevator-hide');
			}
		} else if (me.target.classList.contains('gz-cabin-elevator-hide')) {
			me.target.classList.remove('gz-cabin-elevator-hide');
		}
	}

	window.requestAnimationFrame(
		function() {
			me.checkPosition();
		}
	);

	// un solo checkPosition per frame, anche se arrivano più eventi scroll
	me.ticking = false;
	window.addEventListener('scroll', function() {
		if(me.ticking) return;
		me.ticking = true;
		window.requestAnimationFrame(
			function() {
				me.ticking = false;
				me.checkPosition();
			}
		);
	}, {passive: true});
})();

(notification = () => {
	var me = notification;

	me.create = function(message, duration=5000) {
		var notification_container = document.createElement("div");
		notification_container.classList.add('gz-notification-message');
		notification_container.innerHTML = `<div class="gz-notification-close">
												<span class="gz-icon">
													<svg viewBox="0 0 50 50">
														<use xlink:href="/style/images/icons.svg?cb=${nonce}#icon-burger-close" />
													</svg>
												</span>
											</div>${message}`;
		document.body.appendChild(notification_container);
    	me.attachEvents();

		setTimeout(function() {
	        document.querySelector('.gz-notification-message').classList.add('visible');
	    }, 500);

		me.closeNotification(duration);
	};

    me.attachEvents = function(name) {
		document.querySelector('.gz-notification-close').addEventListener('click', (e) => {
			me.closeNotification();
		});
    };

    me.closeNotification = function(duration = 0) {
		setTimeout(function() {
			if(document.querySelector('.gz-notification-message')){
				document.querySelector('.gz-notification-message').classList.remove('visible');
				setTimeout(() => {
					document.body.removeChild(document.querySelector('.gz-notification-message'));
				}, 1000);
			}
	    }, duration);
    };
})();

(modal = () => {
	var me = modal;
	var selector = '.gz-modal-container';
	me.modals = {};

    me.init = function() {
		var modalContainer = document.querySelectorAll(selector);

    	for(var i = 0; i < modalContainer.length; i++){
			var target = modalContainer[i];
			var name = target.dataset.modalname;
    		me.buildModalObject(name, target);
			me.checkOverlayModal();
    	}

		const openModalElements = document.getElementsByClassName('gz-open-modal');
		for (const el of openModalElements) {
			el.addEventListener('click', event => {
				event.preventDefault();
				var modalName = el.dataset.modaltoopen;
				me.openModal(modalName);
			});
		}
	};

	me.createModal = function(name, title, size) {
		document.body.appendChild(me.structureModal(name, title, size));

		me.buildModalObject(name, document.querySelector(selector+'[data-modalname='+name+']'));
		me.checkOverlayModal();
	};

    me.buildModalObject = function(name, target) {
		me.modals[name] = {
			"target": target,
			open: function() {
				return me.openModal(name);
			},
			close: function() {
				return me.closeModal(name);
			},
			append: function(html) {
				return me.appendModal(name, html);
			}
		}

		target.addEventListener('click', event => {
			if(event.target.closest('.gz-modal-close')) {
				event.preventDefault();
				var modalName = event.target.closest(selector).dataset.modalname;
				me.closeModal(modalName);
			}

			if(event.target.classList.contains('gz-modal-container') && !event.target.classList.contains('gz-modal-blocked')) {
            	var modalName = document.querySelector(selector+'.gz-open').dataset.modalname;
                me.closeModal(modalName);
			}
		});
	}

    me.checkOverlayModal = function() {
		if (Object.keys(me.modals).length > 0 && !document.querySelector('.gz-overlay-modal')) {
			var overlay = document.createElement("div");
			overlay.classList.add("gz-overlay-modal");
			document.body.appendChild(overlay);
		}

		document.querySelector(".gz-overlay-modal").addEventListener('click', event => {
			if(document.querySelector(selector+'.gz-open')){
				var modalName = document.querySelector(selector+'.gz-open').dataset.modalname;
				me.closeModal(modalName);
			}
		});
    };

    me.openModal = function(name) {
    	var target = me.modals[name].target;
		target.classList.add('gz-open');
		document.body.classList.add("gz-modal-open");

		if(typeof mondadoriMediaCarousel === "undefined") {
			mmLoader({
				src: gz_domain + "/js/min/mmCarousel.min.js?cb="+nonce,
				async: true
			});
		}

		/*
		eventAnalytics('Aperta', 'Modale', name+'#'+window.location.href);
		*/

		let openModalEvent = new CustomEvent('openModal', {detail: {modal_name: name}});
		document.dispatchEvent(openModalEvent);
    };

    me.closeModal = function(name) {
    	var target = me.modals[name].target;
		target.classList.remove('gz-open');
		document.body.classList.remove("gz-modal-open");

		/*
		eventAnalytics('Chiusa', 'Modale', name+'#'+window.location.href);
		*/

		let closeModalEvent = new CustomEvent('closeModal', {detail: {modal_name: name}});
		document.dispatchEvent(closeModalEvent);
    };

    me.appendModal = function(name, html) {
		var target = me.modals[name].target;
		target.querySelector(':scope .gz-modal-content').innerHTML = html;

		let openModalEvent = new CustomEvent('appendModal');
		document.dispatchEvent(openModalEvent);
    };

	me.structureModal = function(name, title, size) {
		var structureModalContainer = document.createElement("div");
		structureModalContainer.classList.add("gz-modal-container");
		structureModalContainer.classList.add(`gz-modal-${size}`);
		structureModalContainer.classList.add(`gz-modal-${name}`);
		structureModalContainer.setAttribute("data-modalname", name);

		structureModalContainer.innerHTML = `<div class="gz-modal">
												<div class="gz-modal-header">
												${(title !== '') ? '<h3 class="gz-modal-title">'+title+'</h3>' : ''}
												<a href="#" class="gz-modal-close">Chiudi</a>
											</div>
											<div class="gz-modal-content"></div>
											<div class="gz-modal-footer"></div>`;
		
		return structureModalContainer;
	};

	me.init();
})();

/* NUOVA GESTIONE LOGIN */
(handleUserCommon = () => {
	var huc = handleUserCommon;

	huc.init = () => {
		huc.avatars = document.querySelectorAll('.gz-user-icon');
		// huc.sidebar = document.querySelectorAll('.gz-sidebar-promo');
		
		huc.modal_name = "login-box";
		huc.modal_target = modal.modals[huc.modal_name].target;
		if(huc.modal_target) {
			huc.recaptcha_loaded = false;
			huc.modal_login_panel = huc.modal_target.querySelector(`.gz-modal-login-panel`);
			huc.modal_check_email = document.getElementById("gz-check-email");
			huc.modal_check_email_form = document.getElementById("gz-check-email-form");
			huc.modal_check_email_form_submit = document.getElementById("gz-check-email-form-submit");
			huc.modal_check_email_form_error = document.getElementById("gz-check-email-error-disclaimer");
			huc.modal_valid_email = document.getElementById("gz-user-valid-email");
			huc.modal_login_modify_email = document.getElementById("gz-login-modify-email");
			huc.modal_login_recover_pwd_back = document.getElementById("gz-recover-pwd-back");
			huc.modal_login_recover_pwd_link = document.getElementById("gz-user-login-recover-pwd-link");
			huc.modal_login_recover_pwd_form = document.getElementById("gz-recover-pwd-form");
			huc.modal_login_recover_pwd_form_email = document.getElementById("gz-recover-pwd-form-email"); 
			huc.modal_login_recover_pwd_form_submit = document.getElementById("gz-recover-pwd-form-submit");
			huc.modal_login_recover_pwd_form_success = document.getElementById("gz-recover-pwd-success-disclaimer");
			huc.modal_login_recover_pwd_form_error = document.getElementById("gz-recover-pwd-error-disclaimer");
			huc.modal_login_pages = huc.modal_target.querySelectorAll(`[data-loginpage]`);
			huc.modal_login_redirect = huc.modal_target.querySelectorAll("input[name='redirect']");
			huc.modal_login_login_btn_fb = huc.modal_target.querySelectorAll(".gz-user-login-box-social-btn-fb");
			huc.modal_login_login_btn_apple = huc.modal_target.querySelectorAll(".gz-user-login-box-social-btn-apple");
			huc.modal_login_login_btn_google = huc.modal_target.querySelectorAll(".gz-user-login-box-social-btn-google");

			huc.modal_login_message_discover = document.getElementById("gz-user-login-message-discover");

			huc.modal_check_email_form_recaptcha;
			huc.modal_login_recover_pwd_form_recaptcha;

			huc.processUser();
			huc.bindHandler();
		}

		// huc.customizeSidebar();
	};

	huc.bindHandler = () => {
		if(typeof status1 !== 'undefined' && !status1){
			document.addEventListener("setModalCheckEmail", huc.setModalCheckEmail, false);
			document.addEventListener("setModalRecoverPwd", huc.setModalRecoverPwd, false);
		}

		document.addEventListener("updatePicture", huc.updatePicture, false);
		document.addEventListener("closeModal", huc.closeModal, false);
		document.addEventListener("openLogin", huc.openModal, false);

		huc.modal_check_email_form_submit.addEventListener("click", huc.clickEmailForm, false);
		huc.modal_login_recover_pwd_form_submit.addEventListener("click", huc.clickRecoverPwdForm, false);
		huc.modal_login_modify_email.addEventListener("click", huc.modifyEmail, false);
		huc.modal_login_recover_pwd_link.addEventListener("click", huc.recoverPwd, false);
		huc.modal_login_recover_pwd_back.addEventListener("click", huc.recoverPwdBack, false);
		huc.modal_login_message_discover.addEventListener("click", huc.discoverAdvantages, false);

		for (const el of huc.modal_login_login_btn_fb) {
			el.addEventListener('click', event => {
				eventAnalytics('Scelta modalità', 'Login', 'Facebook');
			}, false);
		}

		for (const el of huc.modal_login_login_btn_apple) {
			el.addEventListener('click', event => {
				eventAnalytics('Scelta modalità', 'Login', 'Apple');
			}, false);
		}

		for (const el of huc.modal_login_login_btn_google) {
			el.addEventListener('click', event => {
				eventAnalytics('Scelta modalità', 'Login', 'Google');
			}, false);
		}

		const openModalElements = document.getElementsByClassName('gz-open-modal-login');
		for (const el of openModalElements) {
			el.addEventListener('click', event => {
				event.preventDefault();
				huc.processLink(el);
			}, false);
		}
	};

	huc.handleLoading = (add) => {
		add ? huc.modal_login_panel.classList.add('loading') : huc.modal_login_panel.classList.remove('loading');
	};

	huc.clickEmailForm = (e) => {
		if(huc.modal_check_email_form.checkValidity()) {
			huc.handleLoading(true);
		}
	};
	
	huc.checkEmailForm = async (e) => {
		if(huc.modal_check_email_form.checkValidity()) {
			let email = huc.modal_check_email_form.email.value;
			try {
				let res = await fetch("/ajax/check-email.php", {
					method: "POST",
					body: new FormData(huc.modal_check_email_form)
				});
				if (res.ok) {
					let json = await res.json();
					if (json.success) {
						eventAnalytics('Scelta modalità','Login','Email');
						if (!json.available) {
							// grecaptcha.reset(huc.modal_check_email_form_recaptcha);
							huc.modal_valid_email.value = email;
							huc.modal_valid_email.readOnly = true;
							huc.setSelectedPage(`login-modal-form`);
							huc.handleLoading();
						} else {
							window.location.href = `https://www.giallozafferano.it/utente/registrazione?email=${email}&redirect=${encodeURIComponent(redirectUrl)}`;
						}
					} else {
						huc.showErrorMessage(huc.modal_check_email_form_error, json.errorMsg);
						eventAnalytics('Errore email','Login',window.location.href,true);
					}
				}
			} catch (e) {
				huc.showErrorMessage(huc.modal_check_email_form_error, e.message);
				eventAnalytics('Errore email','Login',window.location.href,true);
			}
		} else {
			huc.modal_check_email_form.reportValidity();
			eventAnalytics('Errore email','Login',window.location.href,true);
		}
	};

	huc.modifyEmail = () => {
		huc.modal_check_email.focus();
		huc.setSelectedPage(`check-email-form`);
	};

	huc.recoverPwd = (ev) => {
		ev.preventDefault();
		huc.setSelectedPage(`recover-pwd-form`);
	};

	huc.clickRecoverPwdForm = (e) => {
		if(huc.modal_login_recover_pwd_form.checkValidity()) {
			huc.handleLoading(true);
		}
	};
	
	huc.recoverPwdForm = async () => {
		if(huc.modal_login_recover_pwd_form.checkValidity()) {
			let email = huc.modal_login_recover_pwd_form.email.value;
			try {
				let res = await fetch("/utente/recupero-password-do.php", {
					method: "POST",
					body: new FormData(huc.modal_login_recover_pwd_form)
				});
				if (res.ok) {
					let json = await res.json();
					if (json.success) {
						huc.modal_login_recover_pwd_form_success.classList.remove('gz-disclaimer-hide');
						huc.handleLoading();
						huc.setSelectedPage(`recover-pwd-form-success`);
					} else {
						huc.showErrorMessage(huc.modal_login_recover_pwd_form_error, json.errorMsg);
					}
				}
			} catch (e) {
				huc.showErrorMessage(huc.modal_login_recover_pwd_form_error, e.message);
			}
		} else {
			huc.modal_login_recover_pwd_form.reportValidity();
		}
	};

	huc.showErrorMessage = (item, message) => {
		item.querySelector('.gz-disclaimer-text').textContent = message;
		huc.handleLoading();
		item.classList.remove('gz-disclaimer-hide');
	};

	huc.recoverPwdBack = (ev) => {
		ev.preventDefault();
		huc.setupModalCheckEmail();
	};

	huc.processUser = () => {
		if(typeof status1 !== 'undefined' && status1) {
			if(huc.avatars.length){
				if(uImage) {
					huc.avatars.forEach(function(avatar) {
						avatar.innerHTML = `<picture><img class="gz-user-image" src="${uImage}" /></picture>`;
					});
				} else {
					huc.avatars.forEach(function(avatar) {
						avatar.innerHTML = `<picture><img class="gz-user-image" src="https://www.giallozafferano.it/style/images/GZ-placeholder-colored.jpg" /></picture>`;
					});
				}
			}
		}
	};

    huc.updatePicture = (ev) => {
        if(ev.detail.picture_name) {
			huc.avatars.forEach(function(avatar) {
				avatar.innerHTML = `<picture><img class="gz-user-image" src="${ev.detail.picture_name}" /></picture>`;
			});
        }
    };

	huc.processLink = (el) => {
		let action = (el.hasAttribute("data-infoaction") && el.dataset.infoaction != "") ? el.dataset.infoaction : null;
		if(typeof status1 !== 'undefined' && !status1) {
			let redirect = el.hasAttribute("href") ? el.getAttribute("href") : null;
			huc.resetModal();
			huc.setupModalCheckEmail(action, redirect);
			huc.openModal();
		} else {
			if(el.hasAttribute("target") && el.getAttribute("target") == "_blank"){
				window.open(el.getAttribute("href"), "_blank");
			} else {
				window.location.href = el.getAttribute("href");
			}
		}
	};

	// Etichetta dell'evento di apertura modale in base all'azione che l'ha generata
	huc.openModalLabels = {
		ricettari: 'Click su aggiungi al ricettario',
		commenti: 'Click su commenta',
		fotocommenti: 'Click su fotoricette',
		listaspesa: 'Click su lista spesa'
	};

	huc.openModal = (event, source, non_interaction = false) => {
		if(event && event.detail) {
			source = source || event.detail.source;
			non_interaction = non_interaction || !!event.detail.non_interaction;
		}
		eventAnalytics('Apertura modale login', 'Login', source, non_interaction);

		setTimeout(() => {
			document.body.classList.remove("gz-user-overlay-opened");
			document.body.classList.remove("gz-overlay-opened");
		}, 150);

		loadRecaptcha();

		if(event && event.detail.redirect_url != null) {
			huc.setupModalCheckEmail(null, event.detail.redirect_url, (event.detail.email != null) ? event.detail.email : null);
		}		
		modal.openModal(huc.modal_name);	
	};

	huc.closeModal = (event) => {
		if(event.detail.modal_name == huc.modal_name) {
			huc.resetModal();
		}
	};

	huc.resetActions = () => {
		let actions = huc.modal_target.querySelectorAll(`[data-infoaction]`);
		for(const action of actions){
			action.classList.remove('selected');
		}
	};

	huc.resetPages = () => {
		for(const page of huc.modal_login_pages){
			page.classList.remove('selected');
		}
	};

	huc.resetModal = () => {
		huc.resetActions();
		huc.resetPages();
		huc.handleLoading();
		
		let disclaimers = huc.modal_login_panel.querySelectorAll('.gz-disclaimer');
		for (const el of disclaimers) {
			el.classList.add('gz-disclaimer-hide');
		}

		huc.modal_check_email.value = "";
		huc.modal_login_recover_pwd_form_email = "";
		huc.modal_check_email.readOnly = false;

		huc.modal_login_redirect.forEach(function(item){
			item.value = (redirectUrl != "") ? redirectUrl : window.location.href;
		});
		huc.modal_login_login_btn_fb.forEach(function(item){
			item.setAttribute("href", fbLoginUrl + "&state="+ btoa(redirectUrl));
			item.classList.add("gz-user-login-box-social-btn-show");
		});
		huc.modal_login_login_btn_apple.forEach(function(item){
			item.setAttribute("href", appleLoginUrl + "&state="+ btoa(redirectUrl));
			item.classList.add("gz-user-login-box-social-btn-show");
		});
		huc.modal_login_login_btn_google.forEach(function(item){
			item.setAttribute("href", googleLoginUrl + "&state="+ btoa(redirectUrl));
			item.classList.add("gz-user-login-box-social-btn-show");
		});
	};

	huc.setSelectedAction = (action) => {
		let selectedAction = huc.modal_target.querySelector(`[data-infoaction='${action}']`);

		setCookieCommon('gz_reg_action', action,{
			"domain" : '.giallozafferano.it',
			"expires": new Date(Math.floor(Date.now()+15*60000)).toUTCString(),
			"path" : "/",
			"SameSite" : "Lax"
		});

		if(selectedAction){
			selectedAction.classList.add('selected');
		}
	};

	huc.setSelectedPage = (page) => {
		huc.resetPages();
		let selectedPage = huc.modal_target.querySelector(`[data-loginpage='${page}']`);
		
		if(selectedPage){
			selectedPage.classList.add('selected');
		}
	}

	huc.setupModalCheckEmail = (action, redirect, email) => {
		if(redirect) {
			huc.modal_login_redirect.forEach(function(item){
				item.value = redirect;
			});
			huc.modal_login_login_btn_fb.forEach(function(item){
                item.setAttribute("href", fbLoginUrl + "&state="+ btoa(redirect));
            });
			huc.modal_login_login_btn_apple.forEach(function(item){
                item.setAttribute("href", appleLoginUrl + "&state="+ btoa(redirect));
            });
			huc.modal_login_login_btn_google.forEach(function(item){
				item.setAttribute("href", googleLoginUrl + "&state="+ btoa(redirect));
			});
		} else {
			huc.modal_login_redirect.forEach(function(item){
				item.value = (redirectUrl != "") ? redirectUrl : window.location.href;
			});
		}

		if(email){
			huc.modal_check_email.value = email;
		}

		huc.setSelectedPage('check-email-form');

		if(action) {
			huc.modal_target.querySelector('.gz-user-login-message-description').classList.remove('noaction');
			huc.setSelectedAction(action);
		} else {
			huc.modal_target.querySelector('.gz-user-login-message-description').classList.add('noaction');
			
			setCookieCommon('gz_reg_action', '',{
				"domain" : '.giallozafferano.it',
				"expires": new Date(Math.floor(Date.now()+15*60000)).toUTCString(),
				"path" : "/",
				"SameSite" : "Lax"
			});
		}
	};

	huc.setupModalRecoverPwd = (action, redirect) => {
		if(redirect) {
			huc.modal_login_redirect.forEach(function(item){
				item.value = redirect;
			});
			huc.modal_login_login_btn_fb.forEach(function(item){
                item.setAttribute("href", fbLoginUrl + "&state="+ btoa(redirect));
            });
			huc.modal_login_login_btn_apple.forEach(function(item){
                item.setAttribute("href", appleLoginUrl + "&state="+ btoa(redirect));
            });
			huc.modal_login_login_btn_google.forEach(function(item){
				item.setAttribute("href", googleLoginUrl + "&state="+ btoa(redirect));
			});
		} else {
			huc.modal_login_redirect.forEach(function(item){
				item.value = (redirectUrl != "") ? redirectUrl : window.location.href;
			});
		}

		huc.setSelectedPage('recover-pwd-form');

		if(action) {
			huc.modal_target.querySelector('.gz-user-login-message-description').classList.remove('noaction');
			huc.setSelectedAction(action);
		} else {
			huc.modal_target.querySelector('.gz-user-login-message-description').classList.add('noaction');

			setCookieCommon('gz_reg_action', '',{
				"domain" : '.giallozafferano.it',
				"expires": new Date(Math.floor(Date.now()+15*60000)).toUTCString(),
				"path" : "/",
				"SameSite" : "Lax"
			});
		}
	}

	huc.setModalCheckEmail = (event) => {
		let data = huc.setModalData(event.detail);
		huc.setupModalCheckEmail(data.action, data.url);
		huc.openModal(null, event.detail.source || huc.openModalLabels[data.action], event.detail.non_interaction);
	};

	huc.setModalRecoverPwd = (event) => {
		let data = huc.setModalData(event.detail);
		huc.setupModalRecoverPwd(data.action, data.url);
		huc.openModal(null, event.detail.source || huc.openModalLabels[data.action], event.detail.non_interaction);
	};

	huc.setModalData = (data) => {
		var action = data.action;
		var modal = data.modal ? true : false;
		// Se ho cliccato sul cuore e non sono loggato, la finestra di login si apre ma mantengo la stessa url di partenza (senza aggiunta di ? o #)
		var url = (data && data.redirect_url) ? data.redirect_url : redirectUrl;
		if(!(data && data.redirect_url)) {
			if(modal){
				url += `?GZmodal=${modal}`;
			}
			if(action){
				url += `#${action}`;
			}
		}
		
		return {action, modal, url};
	};

	huc.discoverAdvantages = (ev) => {
		ev.preventDefault();
		let anchor = huc.modal_login_message_discover.dataset.anchor;
		eventAnalytics('Altri vantaggi','Login', window.location.href);

		if(anchor) {
			let element = document.getElementById(anchor);
			element.scrollIntoView({behavior: "smooth"});
		}
	};

	huc.customizeSidebar = () => {
		if(document.querySelectorAll('.gz-sidebar-promo')) {
			for(const sidebar of document.querySelectorAll('.gz-sidebar-promo')){
				if(!sidebar.classList.contains('processed')) {
					if(typeof status2 !== 'undefined' && status2) {
						sidebar.innerHTML = `<div class="gz-sidebar-promo-title-cnt">
								<h4 class="gz-sidebar-promo-title">I tuoi servizi</h4>
								<span class="gz-sidebar-promo-club"></span>
							</div>
							<ul class="gz-sidebar-promo-list">
								<li>
									<a href="https://www.giallozafferano.it/utente/scuola-di-cucina/" class="gz-btn-link" title="Scuola di cucina">
										<span class="gz-icon gz-btn-icon">
											<svg viewBox="0 0 50 50">
												<use xlink:href="/style/images/icons.svg?cb=${nonce}#icon-school" />
											</svg>
										</span>
										<span class="gz-btn-label">Scuola di cucina</span>
										<span class="gz-icon gz-btn-more">
											<svg viewBox="0 0 40 40">
												<use xlink:href="/style/images/icons.svg?cb=${nonce}#icon-arrow-go" />
											</svg>
										</span>
									</a>
								</li>
								<li>
									<a href="https://www.giallozafferano.it/utente/video-corsi-cucina/" class="gz-btn-link" title="Corsi di cucina">
										<span class="gz-icon gz-btn-icon">
											<svg viewBox="0 0 50 50">
												<use xlink:href="/style/images/icons.svg?cb=${nonce}#icon-corsi" />
											</svg>
										</span>
										<span class="gz-btn-label">Corsi di cucina</span>
										<span class="gz-icon gz-btn-more">
											<svg viewBox="0 0 40 40">
												<use xlink:href="/style/images/icons.svg?cb=${nonce}#icon-arrow-go" />
											</svg>
										</span>
									</a>
								</li>
								<li>
									<a href="https://www.giallozafferano.it/utente/contenuti-sfogliabili/" class="gz-btn-link" title="Contenuti sfogliabili">
										<span class="gz-icon gz-btn-icon">
											<svg viewBox="0 0 50 50">
												<use xlink:href="/style/images/icons.svg?cb=${nonce}#icon-rivista" />
											</svg>
										</span>
										<span class="gz-btn-label">Contenuti sfogliabili</span>
										<span class="gz-icon gz-btn-more">
											<svg viewBox="0 0 40 40">
												<use xlink:href="/style/images/icons.svg?cb=${nonce}#icon-arrow-go" />
											</svg>
										</span>
									</a>
								</li>
								<li>
									<a href="https://www.giallozafferano.it/utente/chiedi-a-giallozafferano/" class="gz-btn-link" title="Supporto">
										<span class="gz-icon gz-btn-icon">
											<svg viewBox="0 0 50 50">
												<use xlink:href="/style/images/icons.svg?cb=${nonce}#icon-chiedi" />
											</svg>
										</span>
										<span class="gz-btn-label">Supporto</span>
										<span class="gz-icon gz-btn-more">
											<svg viewBox="0 0 40 40">
												<use xlink:href="/style/images/icons.svg?cb=${nonce}#icon-arrow-go" />
											</svg>
										</span>
									</a>
								</li>
							</ul>`;
					}
					sidebar.classList.add('processed');
				}
			}
		}
	};

	if(lang == "it") {
		huc.init();
	}
})();

function checkEmailOnSubmit() {
	if(lang == "it") {
		handleUserCommon.checkEmailForm();
	}
}

function recoverPwdOnSubmit() {
	if(lang == "it") {
		handleUserCommon.recoverPwdForm();
	}
}

function onloadCallback() {
	let recaptcha_btns = document.querySelectorAll('.g-recaptcha');

	for (const el of recaptcha_btns) {
		let recaptcha_id = el.getAttribute('id');
		let recaptcha_callback = el.dataset.callback;
		if(recaptcha_id && recaptcha_callback){
			let recaptcha_widget_id =grecaptcha.render(recaptcha_id, {
				'sitekey': '6Lf4nD4dAAAAAOplXRV61WT904PksJLalKo7VLiy',
				'callback': recaptcha_callback
			});
			el.setAttribute('data-widget-id', recaptcha_widget_id);
		}
	}
};
/* END NUOVA GESTIONE LOGIN */

(handleInput = () => {
	var hi = handleInput;

	hi.init = () => {
		hi.input_fields = document.querySelectorAll('.gz-form-input');
		if(hi.input_fields.length > 0){
			hi.setupInput(hi.input_fields);
		}
	};

	hi.setupInput = (inputs) => {
		for(let i=0; i<inputs.length; i++) {
			if(inputs[i].type === "password") {
				hi.handlePasswordVisibility(inputs[i]);
			}

			inputs[i].addEventListener('keyup', hi.onKeyUp, false);
			inputs[i].addEventListener('blur', (ev) => {
				ev.currentTarget.classList.remove('gz-form-input-active');
			}, false);
		}
	};
	
	hi.onKeyUp = (ev) => {
		if (ev.currentTarget.value.length > 0) {
			ev.currentTarget.classList.add('gz-form-input-active');
		} else {
			ev.currentTarget.classList.remove('gz-form-input-active');
		}
	};

	hi.handlePasswordVisibility = (item) => {
		let show_password = item.parentNode.querySelector('.gz-form-show-password');
		show_password.addEventListener('click', (ev) => {
			if (item.type === "password") {
				show_password.classList.add('hide');
				item.type = "text";
			} else {
				show_password.classList.remove('hide');
				item.type = "password";
			}		
		}, false);
	};

	hi.init();
})();

(handleTextarea = () => {
	var ht = handleTextarea;

	ht.init = () => {
		ht.textareas = document.querySelectorAll('.gz-form-textarea');
		if(ht.textareas.length > 0){
			ht.setupTextarea(ht.textareas);
		}
	};

	ht.setupTextarea = (textareas) => {
		for(let i=0; i<textareas.length; i++) {
			textareas[i].addEventListener('keyup', ht.onKeyUp, false);
			textareas[i].addEventListener('blur', (ev) => {
				ev.currentTarget.classList.remove('gz-form-textarea-active');
			}, false);
		}
	};
	
	ht.onKeyUp = (ev) => {
		let item = ev.currentTarget;
		if(item.hasAttribute('maxlength') && item.parentNode.querySelector('.gz-form-textarea-limit-char')) {
			ht.handleLimitChar(item, ev);
		}

		if (item.value.length > 0) {
			item.classList.add('gz-form-textarea-active');
		} else {
			item.classList.remove('gz-form-textarea-active');
		}
	};

	ht.handleLimitChar = (item, event) => {
		let textarea_val = item.value;
		let textarea_length = textarea_val.length;
		let textarea_maxlength = item.getAttribute("maxlength"); 
		let remain = parseInt(textarea_maxlength - textarea_length);
		item.parentNode.querySelector('.gz-form-textarea-limit-char').innerHTML = remain;
		
		if (event && remain <= 0 && event.which !== 0 && event.charCode !== 0) {
			item.value = (textarea_val.substring(0, textarea_length - 1))
		}
	};

	ht.init();
})();


if (document.querySelectorAll('.gz-description-with-more')){
	(readMore = (container) => {
		var me = readMore;
	
		me.init = () => {
			var containerDescription = document.querySelector(container);
			if(!containerDescription){
				return;
			}
		
			var description = containerDescription.querySelector(":scope .inner") ? containerDescription.querySelector(":scope .inner") : containerDescription;
		
			var heightContainerDescription = containerDescription.offsetHeight;
			var heightDescription = description.offsetHeight;
		
			me.collapse(containerDescription, heightContainerDescription, heightDescription);
		
			if(document.querySelector(container+' .read-more')) {
				document.querySelector(container+' .read-more').addEventListener("click", (event) => {
					event.preventDefault();
					if (containerDescription.classList.contains('opened')) {
						me.close(containerDescription);
					} else {
						me.open(containerDescription, heightDescription);
					}
				});
			}
		}
	
		me.collapse = function(containerDescription, heightContainerDescription, heightDescription) {
			if (heightContainerDescription < heightDescription && !containerDescription.classList.contains('collapsible')) {
				var readMoreBtn = document.createElement("div");
				readMoreBtn.classList.add('read-more');
				readMoreBtn.innerHTML = `<a data-close="${dictionary.close}" data-open="${dictionary.readModeExtended1}" href="#">${dictionary.readModeExtended1}</a></div>`;
		
				containerDescription.classList.add('collapsible');
	
				containerDescription.appendChild(readMoreBtn);
			}
		},
	
		me.open = function(container, height) {
			container.classList.add("opened");
			container.querySelector('.read-more a').textContent = container.querySelector('.read-more a').dataset.close;
		},
	
		me.close = function(container) {
			container.classList.remove("opened");
			container.querySelector('.read-more a').textContent = container.querySelector('.read-more a').dataset.open;
	
			document.querySelector(".gz-page").scrollIntoView({behavior: "smooth", block: "start"});
		}

		me.init();
	})('.gz-description-with-more');
}

(autocompleteGZ = function() {
	me = autocompleteGZ;

	me.init = function() {
		me.url = gz_domain + '/ajax/suggest.php?q=';
		me.target = document.getElementById('gz-header-search-input');
		me.container = document.querySelector('.gz-header-search-container');
		me.tendina = document.querySelector('.gz-tendina');
		me.ul = document.createElement('ul');
		if (me.tendina) me.tendina.appendChild(me.ul);

        // RIMOSSO EVENTO "autocompletition"
        
		// me.ul.addEventListener('click', function(event){
		// 	event.stopImmediatePropagation();
		// 	if (event.target.matches('.gz-tendina-item')) {
		// 		var item = event.target;
		// 		var action = item.dataset.query;
		// 		var label = "pos: " + item.dataset.position + ", suggestion: " + item.dataset.string;

		// 		eventAnalytics(action, 'autocompletition', label);
		// 	}
		// }, false);

		me.onKeyUp();
		me.gestioneFocus();
	}

	me.onKeyUp = function() {
			if (me.target) {
				me.target.addEventListener("keyup", function () {
					if (me.target.value.length > 2) {
						me.urlToCall = me.url + encodeURIComponent(me.target.value);
						me.request();
					} else {
						me.container.classList.remove('gz-tendina-show');
						me.ul.innerHTML = '';
					}
				}, false);
			}
	}

	me.gestioneFocus = function(e) {
		if (me.target) {
			me.target.addEventListener("blur", function(e) {
				me.container.classList.remove('gz-tendina-show');
			}, false);

			me.target.addEventListener("focus", function(e) {
				me.tendina.style.display = 'block';
			}, false);
		}
	}

	me.costruisciTendina = function() {
		if (me.risposta.length == 0) {
			me.container.classList.remove('gz-tendina-show');
			me.tendina.style.display = 'none';
			me.numResultString = '';
		} else {
			me.container.classList.add('gz-tendina-show');
			me.tendina.style.display = 'block';
		}
		me.htmlSting = '';
		me.risposta.forEach((item, index) => {
			var position = index + 1;
			me.strippedString = item.term.replace(/(<([^>]+)>)/ig, "");
			me.htmlSting += `<li>
								<a href="${item.url}" title="${me.strippedString}" class="gz-btn-link gz-tendina-item" data-position="${position}" data-query="${me.target.value}" data-string="${me.strippedString}">
									<span class="gz-icon gz-btn-icon">
										<svg viewBox="0 0 50 50">
											<use xlink:href="/style/images/icons.svg?cb=${nonce}#icon-lens" />
										</svg>
									</span>
									<div class="gz-btn-label">${item.term}</div>
								</a>
							</li>`;
		});
		me.ul.innerHTML = me.htmlSting;
		//Tracciamento TikTok sui risultati di ricerca
		let resultItem = document.querySelectorAll('.gz-tendina-item');
		Array.from(resultItem).forEach(link => {
			link.addEventListener('click', function (e) {
				me.sendTrackingTikTok = function () {
					ttq.track('Search', {
						"query": me.target.value // string. The word or phrase used to search. Example: "SAVE10COUPON".
					});
				}
				if(typeof ttq !== 'undefined') {
					postTcfReady(me.sendTrackingTikTok);
				}
			});
		});
	}


	me.request = function() {
		var request = new XMLHttpRequest();
		request.open('GET', me.urlToCall, true);

		request.onload = function() {
			if (request.status >= 200 && request.status < 400) {
				//Successo
				me.risposta = JSON.parse(request.responseText);
				me.costruisciTendina();
			}
		};

		request.onerror = function() {
			// gestiamo l'errore
		};

		request.send();
	}

	me.init();
})()

var isInViewport = function (elem) {
    var bounding = elem.getBoundingClientRect();

	return (
        bounding.top >= 0 &&
        bounding.left >= 0 &&
        bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
};

function getEventTarget(e) {
	e = e || window.event;
	return e.target || e.srcElement;
}

class Musil {
	constructor(par) {
	  this.data = {
		cl: "mobile",
		dl: document.location.href,
		dm: document.location.host,
		ds: par.ds || "web",
		ec: "musil",
		mt: "android",
		ts: Math.floor(Date.now() / 1000),
		ul: navigator.language,
		ve: "0.0.1",
		wb: par.wb,
	  };
  
	  this.init();
	}
  
	async init()  {
	  if (this.getCookie("musil")) {
		console.log("[Ame Musil Dtct]", "Not Today!");
		return false;
	  }
	  this.deviceType();
	  this.musilIs = await this.tryRequest(this.data);
  
	  this.data.action = { val: this.musilIs };
	  console.log("[Ame Musil Dtct]", this.data);
	  let dati = { records: [{ value: this.data }] };
  
	  this.setCookie("musil", 1, 1);
  
	  console.log("[Ame Musil Dtct]", "Send");
  
	  navigator.sendBeacon('https://endpoint.ets.amedigital.it/topics/musil-stream', JSON.stringify(dati));
	};
  
	getCookie(name) {
	  var v = document.cookie.match("(^|;) ?" + name + "=([^;]*)(;|$)");
	  return v ? v[2] : null;
	};
  
	setCookie (name, value, days) {
	  var d = new Date();
	  d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
	  document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString() +";domain="+
	  document.location.host.split('.').slice(-2).join('.');
	};
  
	deviceType () {
	  const ua = navigator.userAgent;
	  if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
		this.data.cl = "tablet";
	  } else if (
		/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
		  ua
		)
	  ) {
		this.data.cl = "mobile";
	  } else {
		this.data.cl = "desktop";
	  }

	  this.osType();
	};

	osType() {
		let userAgent = navigator.userAgent || navigator.vendor || window.opera;
		this.data.mt = 'other';
		if(/android/i.test(userAgent)) this.data.mt = 'android';
		if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) this.data.mt = 'ios';
	}
  
	async tryRequest (data) {
	  try {
		return fetch(
		  new Request("https://cdn.adsafeprotected.com/iasPET.1.js", {
			method: "HEAD",
			mode: "no-cors",
		  })
		)
		  .then(function (response) {
			// yep!
			console.log("[Ame Musil Dtct]", "No");
			return false;
		  })
		  .catch(function (e) {
			// buuu!
			console.log("[Ame Musil Dtct]", "Sì");
			return true;
		  });
	  } catch (error) {
		console.log(error);
		console.log("[Ame Musil Dtct]", "Check fallito");
	  }
	};
  }
 
  function  musilStart() {
	let musilPar = {
		wb: "gz-site",
	  };
	  let musil = new Musil(musilPar);
  }

  //if(new Date().getHours() == 11) postTcfReady(musilStart);
//musilStart();

// GZ-1333: autorefresh su ricette e speciale nutella
if(gz1333_autorefresh) {
	(autoRefresh = () => {
		var ar = autoRefresh;
		ar.interval = 60000;
		ar.videoStatus = "";

		ar.init = () => {
			ar.isok = true;

			setInterval(() => {
				ar.doRefresh();
			}, ar.interval);

			window.onfocus = function () { ar.isok = true; };
			window.onblur = function () { ar.isok = false; };
		};

		ar.doRefresh = () => {
			if (ar.isok) {
				if(typeof(AVPushRunningInstances) !== "undefined"){
					if(typeof(AVPushRunningInstances[0].api) !== "undefined"){
						ar.videoStatus = AVPushRunningInstances[0].api.getStatus()["currentMode"];
					}
				}
				
				if(ar.videoStatus == "" || ar.videoStatus != "content-playing-hls") {
					window.location.reload(); 
				}
			}
		};

		ar.init();
	})();
}

(newsletterForm = () => {
	var nf = newsletterForm;

	nf.init = () => {
		nf.body = document.body;
		nf.recaptchaLoaded = false;
		nf.newsletter_form = document.getElementById("gz-newsletter-form");
		nf.newsletter_form_checkbox = document.getElementById("gz-newsletter-checkbox");
		nf.newsletter_button = document.getElementById("gz-newsletter-button");
		nf.newsletter_form_confirm = document.getElementById("gz-newsletter-form-confirm");
		nf.newsletter_form_confirm_submit = document.getElementById("gz-newsletter-form-confirm-submit");

		if(nf.newsletter_form) {
			nf.newsletter_form.addEventListener('submit', nf.handleForm);
			nf.newsletter_button.addEventListener('click', nf.handleFormClick); 
		}
	}

	nf.handleForm = (ev) => {
		ev.preventDefault();
		
		if(nf.newsletter_form.email.value != '') {
			nf.newsletter_form_confirm.email.value = nf.newsletter_form.email.value;
			loadRecaptcha();
			modal.openModal("modal-newsletter");
		} 
	}

	nf.handleFormClick = (ev) => {
		if(nf.newsletter_form.email.value != '') {
			eventAnalytics('Click sul bottone Iscriviti ok', 'Newsletter footer', window.location.href);
		} else {
			eventAnalytics('Click sul bottone Iscriviti no email', 'Newsletter footer', window.location.href);
		}
	}

	nf.handleConfirmForm = async () => {
		let message = "Si è verificato un errore";

		if(nf.newsletter_form_confirm.checkValidity()) {
			modal.closeModal("modal-newsletter");
			eventAnalytics('Click sul bottone Conferma ok', 'Newsletter footer', window.location.href);
			try {
				let res = await fetch("https://www.giallozafferano.it/ajax/newsletter.php", {
					method: "POST",
					body: new FormData(nf.newsletter_form_confirm),
				});
				if (res.ok) {
					let json = await res.json();
					if (json.success) {
						if (json.status === "no-operation") {
							message = "Sei già iscritto!";
							eventAnalytics('Click su Conferma sei già iscritto', 'Newsletter footer', window.location.href);
						} else { // registered|updated
							message = "Grazie per esserti iscritto alla newsletter!";
							eventAnalytics('Click su Conferma ok', 'Newsletter footer', window.location.href);
						}
					} else {
						message = json.errorMsg;
					}
				}
			} finally {
				notification.create(message,6000);
			}
		} else {
			nf.newsletter_form_confirm.reportValidity();
			if(!nf.newsletter_checkbox.checked) {
				eventAnalytics('Click sul bottone Conferma no checkbox', 'Newsletter footer', window.location.href);
			}
		}
	}

	nf.init();
})();

function newsletterOnSubmit() {
	newsletterForm.handleConfirmForm();
}

/* Gestione eventi globali */
/*if(document.querySelectorAll('.gz-rivista-link') && status2){
	for(const rivistaLink of document.querySelectorAll('.gz-rivista-link')){
		rivistaLink.addEventListener('click', event => {
			eventAnalytics(rivistaLink.dataset.varsAction, 'GZ Club Servizi', rivistaLink.dataset.varsLabel);    
		});
	}
}*/

if(document.querySelectorAll('.gz-openlogin-link') && document.querySelectorAll('.gz-user-icon').length){
	for(const openLoginLink of document.querySelectorAll('.gz-openlogin-link')){
		openLoginLink.addEventListener('click', event => {
			if (!status1){
				event.preventDefault();
				//Qui il valore selezionato
				let openLoginEvent = new CustomEvent('openLogin', {detail: {redirect_url: window.location.href, source: 'Click su link accedi'}});
				document.dispatchEvent(openLoginEvent);
			}
		});
	}
} 

if(document.querySelectorAll('.gz-footer-download-buttons .gz-store-download-button')){
	for(const footerDownloadButton of document.querySelectorAll('.gz-footer-download-buttons .gz-store-download-button')){
		footerDownloadButton.addEventListener('click', event => {
			eventAnalytics('Store', 'Interazione', footerDownloadButton.dataset.store);    
		});
	}
}

(overlaynewtermsandconditions = () => {
    let me = overlaynewtermsandconditions;

    me.checkCookie = new Promise((resolve, reject) => {
		if (typeof status1 !== 'undefined' && status1 && !aInfos["tosUpdate"]) {
            resolve();
        } else {
            console.log('[overlaynewtermsandconditions] Cookie già settato');
        }
    });

	me.handleModal = () => {
		return new Promise(function (resolve, reject) {
			modal.openModal("tos-box");
			resolve();
		});
    }

    me.addListener = () => {
		let form = document.getElementById("gz-tos-form");
		form.addEventListener("submit", (event) => {
			event.preventDefault();
			if(form.checkValidity()){
				var data = new FormData(form);
				fetch("/utente/accettazione-tos.php", {
					body: new URLSearchParams(data).toString(),
					method: "post",
					headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
				})
				.then(response => response.json())
				.then(data => {
					console.log('Success:', data);
					modal.closeModal("tos-box");
				})
				.catch((error) => {
					console.log(error)
				});
            } else {
                form.reportValidity();
            }
		});
    }
    
	if(lang == "it") {
		me.checkCookie.then(ok => {
			console.log('[overlaynewtermsandconditions] Cookie non settato'); 
			me.handleModal();
		}).then(ok => {
			me.addListener();
		});
	}
})()

function surveyHandler(){
	let sh = this;
	sh.survey_data = {
		name: '',
		daysExpirationClose: 7,
		daysExpirationEnter: 365
	};

	sh.init = (sd) => {
		if(sd) {
			sh.survey_data = sd;
		}

		sh.cookie_close_name = `survey${sh.survey_data.name}`;
		sh.cookie_enter_name = `survey${sh.survey_data.name}_processed`;

		sh.survey_placeholder = document.getElementById("gz-survey");
		if(sh.survey_placeholder) {
			if(device == "smartphone") {
				if(status1 || getCookieCommon(sh.cookie_close_name) || getCookieCommon(sh.cookie_enter_name)) {
					sh.survey_placeholder.remove();
				} else {
					sh.survey_placeholder.classList.add("processed");
					sh.survey_close = document.querySelectorAll(".gz-survey-close");
					sh.bindHandler();
				}
			} else {
				sh.survey_placeholder.remove();
			}
		}
	};

	sh.buildSurvey = () => {
		sh.survey_placeholder.innerHTML =  `<div class="gz-icon gz-survey-close">
												<svg viewBox="0 0 30 30">
													<use xlink:href="/style/images/icons.svg?cb=${nonce}#icon-svuota" />
												</svg>
											</div>
											<span class="gz-survey-text">Per noi di Giallozafferano la tua opinione è importante!</span>
											<a href="${sh.survey_data.link}" title="Partecipa al sondaggio" target="_blank" class="gz-btn-link gz-survey-close gz-survey-enter">
												<span class="gz-btn-label">Partecipa al<br />sondaggio</span>
												<span class="gz-btn-icon gz-icon">
													<svg viewBox="0 0 40 40">
														<use xlink:href="/style/images/icons.svg?cb=${nonce}#icon-arrow-go" />
													</svg>
												</span>
											</a>`;
		sh.survey_placeholder.classList.add("processed");
	};

	sh.bindHandler = () => {
		for (const el of sh.survey_close) {
			el.addEventListener('click', event => {
				sh.closeSurvey();

				if(el.classList.contains("gz-survey-enter")) {
                    setCookieCommon(sh.cookie_enter_name, 1,{
                        "domain" : '.giallozafferano.it',
                        "expires": new Date(Math.floor(Date.now()+sh.survey_data.daysExpirationEnter*86400*1000)).toUTCString(),
                        "path" : "/",
                        "SameSite" : "Lax"
                    });

					eventAnalytics('Click', 'Survey', window.location.href);
				} else {
                    setCookieCommon(sh.cookie_close_name, 1,{
                        "domain" : '.giallozafferano.it',
                        "expires": new Date(Math.floor(Date.now()+sh.survey_data.daysExpirationClose*86400*1000)).toUTCString(),
                        "path" : "/",
                        "SameSite" : "Lax"
                    });

					eventAnalytics('Chiudi', 'Survey', window.location.href);
				}
			});
		}
	};

	sh.closeSurvey = (ev) => {
		/*
		sh.survey_placeholder.classList.remove("processed");
		setTimeout(() => {sh.survey_placeholder.remove();}, 150);
		*/
		sh.survey_placeholder.remove();
	};
}

/* animazione elementi NEW */
(overlaynewtermsandconditions = () => {
	const carousels = document.querySelectorAll('.gz-swiper-effect-mode');

	if(carousels) {
		let observer = new IntersectionObserver((entries, observer) => {
			entries.forEach(entry => {
				if (entry.intersectionRatio == 1 ) {
					entry.target.classList.add('processed');
				}
			});
		}, {threshold: 1, rootMargin: "0px 0px -250px 0px"});
	
		for (const carousel of carousels) {
			observer.observe(carousel);
		}
	}
})();
/* END animazione elementi NEW */

function setCookiePushdown(cname, cvalue, exhours, domain='') {
    // IMPORTANTE - inserire il dato "exhours" in ore indica la scadenza del cookie
    const d = new Date();
    d.setTime(d.getTime() + (exhours * 3600000));
    let expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";domain="+domain + ";path=/";
}

function setCookieCommon(name, value, options = {}) {
    document.cookie = `${name}=${encodeURIComponent(value)}${
	Object.keys(options)
		.reduce((acc, key) => {
			return acc + `;${key.replace(/([A-Z])/g, $1 => '-' + $1.toLowerCase())}=${
				options[key]}`;
		}, '')
	}`;
}

function getCookieCommon(name) {
	const cookies = document.cookie.split(';')
		.reduce((acc, cookieString) => {
			const [key, value] = cookieString.split('=').map(s => s.trim());
			if (key && value) {
				acc[key] = decodeURIComponent(value);
			}
			return acc;
		}, {});
	return name ? cookies[name] || '' : cookies;
}

/* gestione colore skin */
function deltaE(rgbA, rgbB) {
	let labA = rgb2lab(rgbA);
	let labB = rgb2lab(rgbB);
	let deltaL = labA[0] - labB[0];
	let deltaA = labA[1] - labB[1];
	let deltaB = labA[2] - labB[2];
	let c1 = Math.sqrt(labA[1] * labA[1] + labA[2] * labA[2]);
	let c2 = Math.sqrt(labB[1] * labB[1] + labB[2] * labB[2]);
	let deltaC = c1 - c2;
	let deltaH = deltaA * deltaA + deltaB * deltaB - deltaC * deltaC;
	deltaH = deltaH < 0 ? 0 : Math.sqrt(deltaH);
	let sc = 1.0 + 0.045 * c1;
	let sh = 1.0 + 0.015 * c1;
	let deltaLKlsl = deltaL / (1.0);
	let deltaCkcsc = deltaC / (sc);
	let deltaHkhsh = deltaH / (sh);
	let i = deltaLKlsl * deltaLKlsl + deltaCkcsc * deltaCkcsc + deltaHkhsh * deltaHkhsh;
	return i < 0 ? 0 : Math.sqrt(i);
}

function rgb2lab(rgb) {
	let r = rgb[0] / 255, g = rgb[1] / 255, b = rgb[2] / 255, x, y, z;
	r = (r > 0.04045) ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
	g = (g > 0.04045) ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
	b = (b > 0.04045) ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
	x = (r * 0.4124 + g * 0.3576 + b * 0.1805) / 0.95047;
	y = (r * 0.2126 + g * 0.7152 + b * 0.0722) / 1.00000;
	z = (r * 0.0193 + g * 0.1192 + b * 0.9505) / 1.08883;
	x = (x > 0.008856) ? Math.pow(x, 1 / 3) : (7.787 * x) + 16 / 116;
	y = (y > 0.008856) ? Math.pow(y, 1 / 3) : (7.787 * y) + 16 / 116;
	z = (z > 0.008856) ? Math.pow(z, 1 / 3) : (7.787 * z) + 16 / 116;
	return [(116 * y) - 16, 500 * (x - y), 200 * (y - z)]
}

window.addEventListener('skinData', (e) => {
	if(device == 'desktop' && e.detail.url) {
		if(e.detail.color == '#fdfaf9' || e.detail.color == '#FDFAF9') {
			handleBgSkin(e.detail.url);
		}
	}
});

function handleBgSkin(url){
	let startTime = performance.now();
	let page = document.querySelector('.mh2021Page');
	var canvas = document.createElement("canvas");
	var pic = new Image();
	pic.crossOrigin = "Anonymous";
	pic.onload = function () {
		canvas.width = pic.width;
		canvas.height = pic.height;
		var ctx = canvas.getContext("2d");
		ctx.drawImage(pic,0,0);

		var c = canvas.getContext('2d');

		let pointsData = [];

		var pBottomSx = c.getImageData(0, pic.height - 1, 1, 1).data;
		var hexpBottomSx = pBottomSx[0] + "," + pBottomSx[1] + "," + pBottomSx[2];
		pointsData['pBottomSx'] = pBottomSx.slice(0,3);

		var pBottomDx = c.getImageData(pic.width - 1, pic.height - 1, 1, 1).data;
		var hexpBottomDx = pBottomDx[0] + "," + pBottomDx[1] + "," + pBottomDx[2];
		pointsData['pBottomDx'] = pBottomDx.slice(0,3);


		var pTopSx = c.getImageData(0, 0, 1, 1).data;
		var hexpTopSx = pTopSx[0] + "," + pTopSx[1] + "," + pTopSx[2];
		pointsData['pTopSx'] = pTopSx.slice(0,3);


		var pTopDx = c.getImageData(pic.width - 1, 0, 1, 1).data;
		var hexpTopDx = pTopDx[0] + "," + pTopDx[1] + "," + pTopDx[2];
		pointsData['pTopDx'] = pTopDx.slice(0,3);

		let bestColor = '255,255,255';

		let bestDistance = deltaE(pointsData['pTopSx'], pointsData['pTopDx']);
		console.log('[skincolor] distanza top', bestDistance)

		if(hexpTopSx != '255,255,255') bestColor = hexpTopSx;
		
		let distanceBottom = deltaE(pointsData['pBottomSx'], pointsData['pBottomDx']);
		console.log('[skincolor] distanza bottom', distanceBottom);
		if(distanceBottom < bestDistance) {
			bestDistance = distanceBottom;
			bestColor = hexpBottomSx;
		}

		let distanceSideSx = deltaE(pointsData['pBottomSx'], pointsData['pTopSx']);
		console.log('[skincolor] distanza lato sinistro', distanceSideSx);
		if(distanceSideSx < bestDistance) {
			bestDistance = distanceSideSx;
			if(hexpBottomSx != '255,255,255')  bestColor = hexpBottomSx;
		}

		let distanceSideDx = deltaE(pointsData['pBottomDx'], pointsData['pTopDx']);
		console.log('[skincolor] distanza lato destro', distanceSideDx);
		if(distanceSideDx < bestDistance) {
			bestDistance = distanceSideDx;
			if(hexpBottomDx != '255,255,255')  bestColor = hexpBottomDx;
		}
		page.style.backgroundColor = `rgb(${bestColor})`;
		console.log('[skincolor] durata',Math.round(performance.now() - startTime)+'ms');
	}

	pic.src = url;
}


if(!hideRecipeAdv) {
    // [NPA] flusso adv
    (function () {
        // GZ-2559: riusa lo stesso stack IMA della push con consenso (non FreeWheel)
        const startPushNoConsent = () => {
			let iframeVideo = document.querySelector('.gz-type-video .containervideo');
			if(iframeVideo != null) {
				console.log('[pushNoConsent] bloccata per presenza video in pagina');
				return false;
			}

			if (typeof window.canServePushdown !== 'function' || !window.canServePushdown()) {
				console.log('[pushNoConsent] bloccata da guard (hidePushdown/showPushDown/cap)');
				return false;
			}

			if (typeof window.startPushDelay !== 'function') {
				console.log('[pushNoConsent] startPushDelay non disponibile');
				return false;
			}

			window.initStartPushNoConsent = 1;
			console.log('[pushNoConsent] schedule IMA push (delay allineato al consenso)');
			stuckAVPush(targetElementId);
			window.startPushDelay();
        }

        // interstitial NPA se preroll non presente
        // const startInterstitialNoConsent = () => {
        //     // [ NPA ] event listeners per interstital ADK (adv fill se non c'è preroll)
        //     const eventBlocking = [
        //         "adblocker_detected",
        //         "preroll_not_served",
        //         "autoplay_denied",
        //         "triggered_fallback",
        //         "preroll_error"
        //     ];
        //     eventBlocking.forEach(function(e) {
        //         window.addEventListener(e, function() {
        //             if (typeof AdKaora.loadInterstitial === 'function' && !adkPageSlots.displayed.adk_interstitial) {
        //                 console.debug('[ NPA ] init interstitial ADK causa preroll non erogato');
        //                 AdKaora.loadInterstitial("adk_death-div");
        //             }
        //         });
        //     })
        // }

        // catena adv no consent
		
		let adkaoraPath = `https://cdn.adkaora.space/mondadori/generic/prod/adk-init.js`;
        const ADVNoConsentFlow = () => {
			setTimeout(function() {
				mmLoader({
					src: adkaoraPath,
					async: true
				}, "ADVNoConsentFlow")
				// .then(element => {
				// 	document.addEventListener("PWTBidComplete", function(e) {
				// 		console.debug('PWTBid completed.')
				// 		// check slot vuoti:
				// 		let emptyNPASlots = {};
				// 		if(ifrmAdvMh.offsetHeight === 0){
				// 			Object.assign(emptyNPASlots, { 'masthead': divslotnameStrip });
				// 		} else {
				// 			AmeMh.strip_animation();
				// 		}
				// 		if(ifrmAdvBox.offsetHeight === 0){
				// 			Object.assign(emptyNPASlots, { 'box300': divslotnameBox });
				// 		}
				// 		document.dispatchEvent(new CustomEvent("EmptyNPASlot", {
				// 			detail: emptyNPASlots
				// 		}));

				// 	});
				// }, "ADVNoConsentFlow")
				.then(element => {
					// GZ-2559: riattiva push no-consent (delay 5s/10s dentro startPushDelay)
					startPushNoConsent();
					// startInterstitialNoConsent();
				}, "ADVNoConsentFlow");
			},500);
			
        }
		if(lang == "it") {
        	postConsentRejected(ADVNoConsentFlow);
		}
        // debug only:
        // document.addEventListener("EmptyNPASlot", function(e) {
        //     console.debug('[NPA] EmptyNPASlot event:', e.detail);
        // });

    })();

}

stuckAVPush = (id) => {
	window.addEventListener('pushClose', ev => {
		window.removeEventListener('pushClose', stuckAVPush);
		let flyfirstPlacement = document.getElementById(id);  

		if(!flyfirstPlacement.previousElementSibling.classList.contains('flyfirst-title-placement')) {
			flyfirstPlacement.insertAdjacentHTML('beforebegin', `<div class="flyfirst-title-placement gz-title-section gz-uppercase gz-underline gz-mBottom2x">Video del giorno</div>`);
		}
	});
}

/* GESTIONE VISUALIZZAZIONE SEEDTAG A MODALE APERTA */
if(typeof handleSeedtag !== 'undefined' && handleSeedtag){
	document.addEventListener('openModal', (ev) => {
		const styleSeedTagHide = document.createElement('style');
		styleSeedTagHide.classList.add("gz-modal-opened-styles");
		styleSeedTagHide.textContent = `
			#inScreen.st-placement, #inScreen.st-placement .st-reset {
				display: none!important;
				z-index:1!important;
			}
			.st-adunit.st-adunit-inscreen {
				display: none!important;
				z-index:1!important;
			}
			iframe#adk_iframe.filled_iframe, div[id^=adk_interstitial].filled, on-interstitial-closing {
				display: none!important;
				z-index:1!important;
			}
			#adk-closing-x, #adk-timer, #dxFlag, #sxFlag, #adkLabel {
				display: none!important;
				z-index:1!important;
			}
		`;
		document.body.appendChild(styleSeedTagHide);
	});

	document.addEventListener('closeModal', (ev) => {
		const styleSeedTagAdded = document.querySelector('style.gz-modal-opened-styles');
		if(styleSeedTagAdded) {
			styleSeedTagAdded.remove();
		}
	});
}

/* Gestione modale iscrizione newsletter per utente registrato */
(modalUserNewsletter = () => {
	var userNl = modalUserNewsletter;
	userNl.modale = document.querySelector(".gz-modal-user-nl");
	userNl.started = false;
		
	userNl.init = () => {
		let checkUserNlCookie = getTheCookie('newsletterForLoggedUser');
		userNl.annullaBtn = document.querySelector(".gz-modal-user-nl-close");
		userNl.confermaBtn = document.querySelector(".gz-modal-attiva-nl");

		if ((checkUserNlCookie === null || checkUserNlCookie === '') && !window.location.pathname.includes('/utente/elimina.php')){
			userNl.apriModaleNl();

			userNl.annullaBtn.addEventListener('click', userNl.handleAnnulla); 
			userNl.confermaBtn.addEventListener('click', () => {
				userNl.handleConferma();
			}); 
		}
	}

	userNl.apriModaleNl = () => {
		userNl.modale.classList.add('gz-modal-user-nl-open');
	}

	userNl.chiudiModaleNl = () => {
		userNl.modale.classList.add('gz-modal-user-nl-closed');
	}

	userNl.handleAnnulla = () => {
		setTheCookie("newsletterForLoggedUser", 'annullaPromoNL', 7);
		userNl.chiudiModaleNl();
		eventAnalytics('Click su annulla promo NL', 'Interazione');
	}

	userNl.handleConferma = async () => {
		let message = "Si è verificato un errore";
		const location = "/utente/newsletter.php";
		const pixelCheckbox = document.getElementById("gz-modal-user-nl-pixel");
		const settings = {
			method: "POST",
			body: "confirm=1&nsl_pixel=" + (pixelCheckbox && pixelCheckbox.checked ? "1" : "0"),
			headers: {"Content-Type": "application/x-www-form-urlencoded"}
		};

		userNl.chiudiModaleNl();
		
		try {
			let res = await fetch(location, settings);
			if (res.ok) {
				let json = await res.json();
				if (json.success) {
					if (json.status === "no-operation") {
						message = "Sei già iscritto!";
					} else {
						message = "Grazie per esserti iscritto alla newsletter!";
						eventAnalytics('Click su attiva promo NL', 'Interazione');
					}
				} else {
					message = json.errorMsg;
				}
			}
		} finally {
			notification.create(message,6000);
		}
	}

	userNl.startWhenAllowed = () => {
		if (userNl.started) return;
		userNl.started = true;

		if (typeof aInfos !== 'undefined' && !aInfos.nsl) {
			if(!showPushDown) {
				userNl.init();
			}else{
				window.addEventListener('preroll_not_served', () => {
					userNl.init();
				}, { once: true });
				window.addEventListener('flight_auto_closed', () => {
					userNl.init();
				}, { once: true });
				window.addEventListener('flight_closed', () => {
					userNl.init();
				}, { once: true });
			}
		}else if (userNl.modale) {
			userNl.modale.style.display = 'none';
		}
	};

	// La newsletter parte solo quando il flusso della nuova informativa privacy è concluso:
	// - subito se la modale informativa non deve comparire
	// - dopo closeModal se la modale della nuova informativa viene mostrata
	if (lang == "it") {
		window.addEventListener('overlayConditions:ready', () => {
			userNl.startWhenAllowed();
		}, { once: true });
	}
})();

/* Modale per conferma consensi nuova informativa */
(overlaynewConditions = () => {
    let me = overlaynewConditions;
	me.isOpen = false;

	// Se l'utente è loggato e privacyUpdate esiste ed è false, mostro popup bloccante
	me.mustShowOverlay = () => {
		return typeof status1 !== 'undefined'
			&& status1
			&& typeof aInfos !== 'undefined'
			&& aInfos
			&& typeof aInfos["privacyUpdate"] !== 'undefined'
			&& aInfos["privacyUpdate"] === false;
	};

	me.notifyReady = () => {
		window.dispatchEvent(new CustomEvent('overlayConditions:ready'));
	};

	me.handleModal = () => {
		modal.openModal("informativa-consent");
		me.isOpen = true;
    }

    me.addListener = () => {
		let form = document.getElementById("gz-informativa-consent-form");
		console.log('[overlaynewConditions] listener');
		if (!form) return;

		form.addEventListener("submit", (event) => {
			event.preventDefault();

			if(form.checkValidity()){
				var data = new FormData(form);
				fetch("https://www.giallozafferano.it/utente/modifica-impostazioni-do.php", {
					body: new URLSearchParams(data).toString(),
					method: "post",
					credentials: "include", // il popup compare anche su ricette.giallozafferano.it: serve il cookie di sessione
					headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
				})
				.then(response => response.json())
				.then(data => {
					console.log('Success:', data);
					modal.closeModal("informativa-consent");
				})
				.catch((error) => {
					console.log(error);
					console.log('[overlaynewConditions] submit error');
				});
            } else {
                form.reportValidity();
				console.log('[overlaynewConditions] form non valido');
            }
		});
    }

	me.addCloseListener = () => {
		document.addEventListener('closeModal', (ev) => {
			if (ev.detail && ev.detail.modal_name === "informativa-consent" && me.isOpen) {
				me.isOpen = false;
				me.notifyReady();
			}
		});
	};
    
	if(lang == "it") {
		if (me.mustShowOverlay()) {
			me.handleModal();
			me.addCloseListener();
			me.addListener();
		} else {
			me.notifyReady();
		}
	}
})();

/* Helper functions to set and get cookies */
function getTheCookie(cookieName) {
	var v = document.cookie.match("(^|;) ?" + cookieName + "=([^;]*)(;|$)");
	return v ? v[2] : null;
};

function setTheCookie(cookieName, cookieValue, cookieDays) {
	var d = new Date();
	d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * cookieDays);
	document.cookie = cookieName + "=" + cookieValue + ";path=/;expires=" + d.toGMTString() +";domain="+
	document.location.host.split('.').slice(-2).join('.');
};

/* Gestione modale coupon */
const CouponManager = {
    selectors: {
        modalName: '[data-modalname="coupon-detail"]',
        cards: '.gz-card-coupon',
        copiedClass: 'gz-modal-coupon-copied'
    },

    state: {
        couponData: {},
        modalElement: null
    },

    init() {
        this.modalElement = document.querySelector(this.selectors.modalName);
        if (!this.modalElement) return;

        this.bindEvents();
    },

    bindEvents() {
        const cards = document.querySelectorAll(this.selectors.cards);
        cards.forEach(card => {
            card.addEventListener('click', () => this.handleCardClick(card));
        });
    },

    async handleCardClick(card) {
        const idCoupon = card.dataset.idcoupon;
        
        if (this.state.couponData[idCoupon]) {
            this.populateModal(this.state.couponData[idCoupon]);
            return;
        }

        try {
            card.classList.add('loading');
            const data = await this.fetchCouponData(idCoupon);
            this.state.couponData[idCoupon] = data;
            this.populateModal(data);
        } catch (error) {
            console.error('Errore nel caricamento del coupon:', error);
        } finally {
            card.classList.remove('loading');
        }
    },

    async fetchCouponData(idCoupon) {
        const response = await fetch(`${location.origin}${location.pathname}/modal?id=${idCoupon}${location.search.replace(/^\?/, '&')}`);
        return response.json();
    },

    populateModal(data) {
        const fields = this.modalElement.querySelectorAll('[data-field]');
        
        fields.forEach(element => {
            const field = element.dataset.field;
            const value = data[field];

            switch (field) {
                case 'image':
                    element.src = value;
                    break;
                case 'modal_text':
                    element.innerHTML = value;
                    break;
                case 'coupon_cta':
                    element.href = data.url; // non c'è il break perché è necessario anche il default
                default:
                    element.textContent = value;
            }
        });

        if (data.coupon) {
            this.modalElement
                .querySelector('[data-field="coupon_btn"]')
                .addEventListener('click', () => this.clipText(data.coupon));
        }

        modal.openModal("coupon-detail");
    },

    clipText(text) {
        navigator.clipboard.writeText(text)
            .then(() => {
                const toggleCopiedState = (action) => 
                    this.modalElement.classList[action](this.selectors.copiedClass);
                
                toggleCopiedState('add');
                setTimeout(() => toggleCopiedState('remove'), 3000);
            })
            .catch(err => console.error('Errore nella copia:', err));
    }
};
document.addEventListener('DOMContentLoaded', () => CouponManager.init());


/** Assistant AI - gestione apertura/chiusura chat **/
function ToggleDivsAssistant() {
	var td = this;
	td.init = function() {
		td.overlay = document.querySelectorAll('.close-overlay, .aimodal-overlay');
		td.ai_handles = document.querySelectorAll('.openai-assistant');
		td.ai_content = document.getElementById('ai-assist');

		// chiusura chat al click su close o sul layer
		Array.from(td.overlay).forEach((el) => {
			el.addEventListener('click', (e)=>{
				//console.debug(el);
				e.preventDefault();
				document.body.classList.remove('aimodal_open');
				document.body.classList.remove('fixed');
				td.ai_content.classList = 'minimized';

				// Evento per chiudere connsessione attiva alla chiusura della modale
				const eventCloseModalAI = new Event("closeModalAI");
				window.dispatchEvent(eventCloseModalAI);
			});
		});

		// apertura/chiusura AI modal
		Array.from(td.ai_handles).forEach((el) => {
			el.addEventListener('click', (e)=>{
				e.preventDefault();

				eventAnalytics('Click su pulsante AI', 'Interazione');

				td.ai_content.classList.add(el.dataset.aiOrigin);
				td.ai_content.classList.toggle('minimized');
				document.body.classList.toggle('aimodal_open');
				document.body.classList.toggle('fixed');

				if (!td.ai_content.classList.contains('minimized')) {
					// Dispathc evento per gestire il preroll con audio on all'apertura della chat
					const eventOpenModalAI = new Event("openModalAI");
					window.dispatchEvent(eventOpenModalAI);
				}

				if (document.body.classList.contains('aimodal_open')) {
                    AAIModalOpen = true;
                }

				if (el.dataset.aiOrigin != 'prefooter') {
					document.body.style.top = 0;
				}
				if (typeof(initAssistant) === 'undefined') {
					mmLoader({
						src: "/js/min/fe_ai-client.min.js?cb="+nonce,
					    async: false
					}, "assistantIAChain")
					.then( () => mmLoader({
					    //src: "https://unpkg.com/showdown/dist/showdown.min.js",
						src: "/js/assistant/showdown.min.js",
					    async: true
					}, "assistantIAChain") )
					.then( () => mmLoader({
					    //src: "https://unpkg.com/typewriter-effect@latest/dist/core.js",
						src: "/js/assistant/typewriter-effect@2.21.0.min.js",
					    async: true
					}, "assistantIAChain") )
					.then( () => mmLoader({
						href: "/style/min/assistant-ai.min.css?cb="+nonce,
					    rel: "stylesheet"
					}, "assistantIAChain", "link") )
					.then( () => {
						__chatWithAssistant = new chatWithAssistant();
					   	__chatWithAssistant.preflightCheck(el.dataset.aiOrigin);
					})
				}else{
					if (__chatWithAssistant.socket.readyState != 1) {
                        //console.debug('CHAT riaperta');
                        __chatWithAssistant.wakeUpAssistant();
                    }
				}
			});
		});

	}
}

if(lang == "it") {
	var __chatWithAssistant;
	var __ToggleDivsAssistant = new ToggleDivsAssistant();
	__ToggleDivsAssistant.init();
}
/** Assistant AI - end **/

function getDeviceType() {
	const userAgent = navigator.userAgent;
	if (/Mobi|Android/i.test(userAgent)) {
		return "Mobile";
	} else if (/Tablet|iPad/i.test(userAgent)) {
		return "Tablet";
	} else {
		return "Desktop";
	}
}
//console.log(`Device Type: ${getDeviceType()}`);

/*** GZHeader ***/
/* deriva da gzheader.js - eliminato il file dai template standard, rimane solo come file separato nella sezione in edicola dove non c'è il common.js */
var itemsRaccomandatore = null;

/* search module */
(function(){
	if(typeof GZheader === "undefined") { GZheader = {}; }

	var search_input,
		search_form,
		search_button,
		search_params,
		search_close_button,
		search_input_placeholder,
		header,
		scrollTop,
		scrollOffset;

	function init(params){
		if(typeof params !== "undefined" && Object.keys(params).length > 0){
			search_params = params;
		} else {
			search_params = {};
		}

		search_container = document.getElementsByClassName("gz-header-search-container")[0];
		search_input = document.getElementsByClassName("gz-header-search-input")[0];
		search_form = document.getElementsByClassName("gz-header-search-form")[0];
		search_button = document.getElementById("gz-header-search");
		search_close_button = document.getElementById("gz-header-search-close");
		search_input_placeholder = search_params.placeholder ? search_params.placeholder : dictionary.searchARecipe;
		header = document.getElementById("gz-header");
		scrollTop = 0;
		scrollOffset = 50;
		bindHandlers();
	}

	function bindHandlers(){
		search_input.addEventListener('input', handleTyping, false);

		if(search_button && search_close_button){
			search_button.addEventListener('click', toggleSearch, false);
			search_close_button.addEventListener('click', toggleSearch, false);
			if(search_params.submitCallback){
				search_form.addEventListener('submit', function(ev){
					window[search_params.submitCallback](ev);
				}, false);
			}
		}

		if(search_input_placeholder && search_params.visible){
			search_input.placeholder = search_input_placeholder;
		}
	}

	function toggleSearch(ev){
		ev.preventDefault();
		ev.stopImmediatePropagation();
		if(header.classList.contains("gz-header-search-opened")){
			header.classList.remove("gz-header-search-opened");
			setTimeout(() => {
				search_container.style.display = "none";
			}, 50);
			search_input.blur();
			window.removeEventListener("scroll", handleScroll);
		} else {
			search_input.focus();
			search_input.placeholder = search_input_placeholder;
			search_container.style.display = "grid";
			setTimeout(() => {
				header.classList.add("gz-header-search-opened");
			}, 50);

			if(device != "desktop") {
				window.addEventListener("scroll", handleScroll, false);
			}
		}
	}

	function handleTyping(ev){
		if(search_input.value.length != 0){
			search_container.classList.add("gz-header-search-active");
		} else {
			search_container.classList.remove("gz-header-search-active");
		}
	}

	function handleScroll(ev) {
		scrollTop = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
		if(scrollTop > scrollOffset){
			closeSearch();
		}
	}

	function closeSearch(ev){
		if(header.classList.contains("gz-header-search-opened")){
			header.classList.remove("gz-header-search-opened");
			search_input.placeholder = "";
			search_input.blur();
			window.removeEventListener("scroll", handleScroll);
		}
	}

	GZheader.search = init;
}());

/* build user menu module */
(function(){
	if(typeof GZheader === "undefined") { GZheader = {}; }

	var html,
		body,
		user_login_icon;

	function init(){
		html = document.getElementsByTagName("html")[0];
		body = document.getElementsByTagName("body")[0];
		user_login_icon = document.getElementById("gz-user-login");

		if(user_login_icon){
			bindHandlers();
		}
	}

	function bindHandlers(){
		if(status1) {
			user_login_icon.removeEventListener("click", openLogin, false);
			user_login_icon.addEventListener("click", openUserProfile, false);
		} else {
			user_login_icon.addEventListener("click", openLogin, false);
		}
	}

	function openLogin(ev) {
		let openLoginEvent = new CustomEvent('openLogin', {detail: {redirect_url: window.location.href, source: 'Click su accedi header'}});
		document.dispatchEvent(openLoginEvent);
	}

	function openUserProfile(ev) {
		window.location.href = "https://www.giallozafferano.it/utente/index/";
	}
	
	GZheader.userMenu = init;
}());

/* menuManager module */
(function(){
	if(typeof GZheader === "undefined") { GZheader = {}; }

	var children;

	function init(){
		if(!document.getElementById("gz-header-nav") || !document.getElementById("gz-header-overlay-nav")){
			return;
		}
		
		children = document.querySelectorAll(".gz-header-has-children");

		for(var i = 0; i < children.length; i++) {
			buildAccordion(children[i]);
		}

		checkSelected("nav");
		checkSelected("overlay-nav");
	}

	function checkSelected(navType){
		var nav = document.getElementById("gz-header-" + navType);
		var selectedElements = nav.querySelectorAll(".selected");

		if(selectedElements.length > 0){
			var lastOfSelected = selectedElements[selectedElements.length-1];

			for (var i = (navType == "nav") ? 1 : 0; i < selectedElements.length; i++) {
				if(selectedElements[i] != lastOfSelected && selectedElements[i].classList.contains("selected")){
					selectedElements[i].classList.remove("selected");
				}
			}
		}
	}

	function buildAccordion(item){
	    var target = item;
	    if(target.classList.contains("selected")){
	    	target.classList.add("opened");
	    }

	    var links = target.querySelectorAll('.gz-header-has-children a');
	    for (var i = 0; i < links.length; i++) {
		    links[i].addEventListener('click', function (ev) {
		        ev.stopPropagation();
		    });
	    }

	    target.addEventListener('click', handleAccordion, false);
	}

	function handleAccordion(ev){
		ev.preventDefault();
		ev.stopPropagation();
		var currentTarget = this;

		if(currentTarget.classList.contains("opened")){
			currentTarget.classList.remove("opened");
		} else {
			checkOpened();
			currentTarget.classList.add("opened");
		}
	}

	function checkOpened(){
		var overlay_nav = document.getElementById("gz-header-overlay-nav");
		var opened = overlay_nav.querySelectorAll('.opened');

		if(opened.length){
			for(var i = 0; i<opened.length; i++){
				opened[i].classList.remove("opened");
			}
		}
	}

	GZheader.menuManager = init;
}());

/* stickyHeader module */
(function(){
	if(typeof GZheader === "undefined") { GZheader = {}; }

	var body,
		header,
		nav,
		secondLevelNavs,
		strip_adv,
		pamela,
		stuck,
		ticking;

	function init(){
		body = document.getElementsByTagName("body")[0];
		header = document.getElementById("gz-header");
		nav = document.getElementById("gz-header-nav");
		secondLevelNavs = nav ? nav.querySelectorAll('.gz-header-mainmenu') : null;
		strip_adv = document.getElementById("gpt_strip_adv");
		pamela = document.getElementById("av-pushdown-wrapper");
		stuck = false;
		ticking = false;

		if(device == "desktop" || (typeof sticky_active !== 'undefined' && sticky_active)) {
			window.addEventListener("scroll", onScroll, {passive: true});
		}
	}

	// un solo handleSticky per frame, anche se arrivano più eventi scroll
	function onScroll(){
		if(ticking) return;
		ticking = true;
		window.requestAnimationFrame(function(){
			ticking = false;
			handleSticky();
		});
	}

	function getOffsetTop(){
		var offset = 0;

		return offset;
	}

	function handleSticky(){
		// var stick_point = getOffsetTop() + strip_adv.offsetHeight + pamela.offsetHeight;
		var stick_point = getOffsetTop() + (document.getElementById("mh2021") ? document.getElementById("mh2021").firstElementChild.offsetHeight : 0);
		var distance = stick_point - window.pageYOffset;
		var offset = window.pageYOffset;

		if(!body.classList.contains("pushing")){
			if (distance <= 0 && !stuck) {
				body.classList.add("gz-sticky");
				header.classList.add("gz-header-sticky");
				stuck = true;
			} else if (stuck && (offset <= stick_point)){
				body.classList.remove("gz-sticky");
				header.classList.remove("gz-header-sticky");
				stuck = false;
			}
		}

		if(!secondLevelNavs){
			return;
		}
		
		positionSecondLevelNavs();
	}

	function positionSecondLevelNavs(){
		// il ramo non sticky assegnava a style.top un numero senza unità, che il browser ignora:
		// rimosso perché non aveva effetto ma forzava comunque un layout leggendo offsetHeight
		if(!body.classList.contains("pushing") && header.classList.contains("gz-header-sticky")){
			for (var i = 0; i < secondLevelNavs.length; i++) {
				if(secondLevelNavs[i].style.top !== "auto"){
					secondLevelNavs[i].style.top = "auto";
				}
			}
		}
	}

	GZheader.stickyHeader = init;
}());

/* handlers module */
(function(){
	if(typeof GZheader === "undefined") { GZheader = {}; }

	var body,
		html,
		hamburger,
		close_button,
		close_panel,
		open_menu,
		nav_overflow_menu,
		pageYOffset;

	function init(){
		html = document.getElementsByTagName("html")[0];
		body = document.getElementsByTagName("body")[0];
		hamburger = document.getElementById("gz-header-hamburger");
		user_login = document.getElementById("gz-user-login");
		open_menu = document.getElementsByClassName("gz-header-open-menu");
		close_button = document.getElementById("gz-header-overlay-close");
		close_panel = document.getElementById("gz-header-overlay-close-panel");
		nav_overflow_menu = document.getElementById("gz-header-nav-overflow-menu");
		header_overlay = document.getElementById("gz-header-overlay");
		lang_switch = document.getElementById("gz-header-translation-link");
		bindHandlers();
	}

	function bindHandlers(){
		hamburger.addEventListener("click", toggleOverlay, false);
		for (var i = 0; i < open_menu.length; i++) {
			open_menu[i].addEventListener("click", toggleOverlay, false);
		}
		close_button.addEventListener("click", toggleOverlay, false);
		if(nav_overflow_menu){
			nav_overflow_menu.addEventListener("click", toggleOverlay, false);
		}		
		close_panel.addEventListener("click", hideOverlay, false);

		if (lang_switch) {
			lang_switch.addEventListener('click', event => {
				eventAnalytics('Click su bandierine in header', 'Interazione', window.location.href);
			});
		}

		// click su "lingue"
		for (const el of document.querySelectorAll(".gz-header-flag")) {
			el.addEventListener('click', event => {
				eventAnalytics('Click su bandierine in burger', 'Interazione', el.dataset.lang);
			});
		}
	}

	function toggleOverlay(ev){
		ev.preventDefault();
		ev.stopImmediatePropagation();
		if(body.classList.contains("gz-header-overlay-opened")){
			body.classList.remove("gz-header-overlay-opened");
			window.scrollTo(0,pageYOffset);
			document.removeEventListener("touchmove", preventScroll, false);
		} else {
			pageYOffset = window.pageYOffset;
			body.classList.add("gz-header-overlay-opened");
			document.addEventListener("touchmove", preventScroll, false);
		}
	}

	function preventScroll(ev){
	    if(!findParentByClassName(ev.target, "gz-header-overlay-opened")){
	    	ev.preventDefault();
	    }
	}

	function hideOverlay(ev){
		if(body.classList.contains("gz-header-overlay-opened")){
			body.classList.remove("gz-header-overlay-opened");
			document.removeEventListener("touchmove", preventScroll, false);
		}
	}

	function findParentByClassName(el,className) {
    	while (el.parentNode && el.parentElement !== html) {
        	el = el.parentNode;
        	if (el.classList.contains(className)){
            	return el;
        	}
    	}
    	return null;
	}

	GZheader.handlers = init;
}());

/*
Inizializzazione GZheader
- popolamento logo
- popolamento del menù di navigazione presente nell'overlay
- gestione del funzionamento del menù
- gestione sticky header allo scroll
- bind eventi generici
*/
if(typeof GZheaderOptions !== "undefined") {
	(function(o){
		if(typeof o === "undefined") { return; }
		var GZheaderOptions = JSON.parse(JSON.stringify(o));
	
		GZheader.menuManager();
		GZheader.stickyHeader();
		GZheader.userMenu();
		GZheader.handlers();
	
		for(var i in GZheaderOptions){
			if(i !== "topstrip"){
				if(GZheaderOptions[i]){
					if(GZheader[i]){
						if(typeof GZheaderOptions[i] !== "boolean"){
							GZheader[i](GZheaderOptions[i]);
						} else {
							GZheader[i]();
						}
					}
				} 
			}
		}
	})(GZheaderOptions);
}
/*** GZHeader - end ***/

(function() {
	if (searchUrl === "" || searchUrl === null) return; // se non c'è la searchUrl, non faccio nulla, perché le related non punterebbero a nulla
    // Ricerche correlate
	const styleId = lang === "it" ? "6527174170" : "6117526270";
    const relatedDiv = "relatedSearchesLeaf";

    const rsblockArticle = {
        "container": relatedDiv,
        "relatedSearches": 6
    };

	const pageOptions = {
		"pubId": "partner-pub-7835681492882497", // Assicurati che l'ID cliente sia corretto.
		"styleId": styleId,
		"resultsPageBaseUrl": searchUrl + "?utm_campaign=related", // Inserisci l'URL di base per la pagina dei risultati
		"resultsPageQueryParam": "q" // (Valore predefinito: "q") Corrisponde al parametro che identifica la query nella pagina di ricerca
	};
    
    postTcfReady(()=>{
        mmLoader({
                src: "https://www.google.com/adsense/search/ads.js",
                async: true
            }, "adsChain");

        (function(g,o){g[o]=g[o]||function(){(g[o]['q']=g[o]['q']||[]).push(
        arguments)},g[o]['t']=1*new Date})(window,'_googCsa');

		const loc = document.location;
        if(loc.href.includes(searchUrl)){
            let params = new URL(loc).searchParams;
			if(params.get("utm_campaign") === null || params.get("q") === null){
				console.error("[ads ricerca] - NO related -> noadv");
				return
			}
            let queryGet = params.get("q");
			console.log("[ads ricerca] -  -> check", queryGet);
			const containerName = "adscorrelaticontainer";

			const adblock1 = {
                "container": containerName,
				"adLoadedCallback" : function(containerName, adsLoaded,
					isExperimentVariant, callbackOptions) {
                        const selectorContainer = document.querySelector("#" + containerName);
						selectorContainer.classList.add("adv-checked", "gz-pBottom3x");
						if (!adsLoaded) {
							console.log ("[ads ricerca] - no ads");
							selectorContainer.classList.add("no-adv");
							selectorContainer.classList.remove("gz-pBottom3x");
						}
				  }
            };

            pageOptions.query = queryGet; // Assicurati che la query inserita qui sia corretta.
            pageOptions.adsafe = "high";
            _googCsa('ads', pageOptions, adblock1);

        } else {
            const relatedLeaf = document.querySelector("#"+relatedDiv);

            if(relatedLeaf){
            	pageOptions.relatedSearchTargeting = "content";
                _googCsa('relatedsearch', pageOptions, rsblockArticle);
            }

			const engageLayer = document.querySelector(".md-engageLayer");
			if (engageLayer && device === "smartphone" && lang === "it") {
				if(engageLayer.querySelector(".relatedEngageLayer-articles")) {
					mmLoader({
						src: "/js/min/md_engage_layer.min.js?cb=" + nonce,
						async: true
					}, "mdEngageLayerChain").then(() => {
						MdEngageLayer.init({pageOptions: null, rsblock1: null, adslot: "6394543912"});
					});
				}
			}
		}
    });

})();

/**
 * Utility: observer per il lazy-load delle immagini di background.
 * Carica l'immagine thumbnail quando il container sta per entrare in viewport.
 */
function createLazyBackgroundObserver(opts) {
    const {
        containerSelector,
        itemSelector,
        thumbSelector,
        rootMargin = '150px 10px 150px 10px',
        threshold = 0.01
    } = opts;

    const containers = document.querySelectorAll(containerSelector);
    if (!containers.length) return null;

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (!entry.isIntersecting) return;

            console.log(`[LazyBg observer] ${containerSelector}`);

            const items = entry.target.querySelectorAll(itemSelector);
            if (!items.length) {
                // Se non ci sono item da gestire, stacco l'observer
                observer.unobserve(entry.target);
                return;
            }

            for (const item of items) {
                const thumb = item.dataset['thumbnail'];
                if (thumb) {
                    const el = item.querySelector(thumbSelector);
                    if (el) {
                        el.style.backgroundImage = `url(${thumb})`;
                    }
                }
            }
            // Caricata l'immagine, stacco l'observer
            observer.unobserve(entry.target);
        });
    }, { threshold, rootMargin });

    for (const container of containers) {
        observer.observe(container);
    }

    return observer;
}

/**
 * Utility: gestione video YouTube con facade cliccabile (nasconde facade, carica/avvia player).
 */
function createYoutubeFacadeManager(opts) {
    const {
        cardSelector,
        containerIdPrefix,
        getVideoId = (card) => card.dataset.videoid
    } = opts;

    const mgr = {};

    mgr.loadingYT = false;
    mgr.loadedYT = false;
    mgr.video_players = [];
    mgr.cards = document.querySelectorAll(cardSelector);

    mgr.init = () => {
        mgr.bindHandler();
        // Precarico l'API YouTube così, al primo click/tap,
        // il player è già pronto e il video parte subito (anche su iOS).
        mgr.loadYT();
        console.log(`[Video facade] ${cardSelector}: init`);
    }

    mgr.loadYT = () => {
        // Se l'API YouTube è già presente, non ricarico lo script
        if (window.YT && window.YT.Player) {
            mgr.loadedYT = true;
            mgr.loadingYT = false;
            return;
        }

        if (!mgr.loadedYT && !mgr.loadingYT) {
            // Flag globale per evitare di iniettare più volte lo script
            if (!window._gzYoutubeApiRequested) {
                window._gzYoutubeApiRequested = true;
                mmLoader({
                    src: "https://www.youtube.com/iframe_api",
                    async: true
                });
				console.log('[Video facade]: load YouTube API');
            }
            mgr.loadingYT = true;
        }
    };

    mgr.setLoaded = () => {
        mgr.loadedYT = true;
        mgr.loadingYT = false;
    };

    mgr.stopOtherVideos = (videoId) => {
        for (const p of mgr.video_players) {
            if (p.id !== videoId) {
                p.player.stopVideo();
            }
        }
    };

    mgr.stopVideos = () => {
        for (const p of mgr.video_players) {
            p.player.stopVideo();
        }
    };

    mgr.loadVideo = (videoId) => {
        mgr.stopOtherVideos(videoId);

        const existing = mgr.video_players.find(p => p.id === videoId);
        if (existing) {
            existing.player.playVideo();
            return;
        }

        if (mgr.loadedYT) {
            const player = new YT.Player(`${containerIdPrefix}${videoId}`, {
                videoId: videoId,
                events: {
                    'onReady': mgr.onPlayerReady,
                    'onStateChange': mgr.onPlayerStateChange
                },
                playerVars: {
                    mute: 0,
                    autoplay: 1,
                    modestbranding: 1,
                    showinfo: 0
                }
            });

            mgr.video_players.push({ id: videoId, player });
        } else {
            mgr.loadYT();
            setTimeout(() => mgr.loadVideo(videoId), 250);
        }
    };

    mgr.onPlayerReady = () => {};
    mgr.onPlayerStateChange = (ev) => {
        if (ev.data === YT.PlayerState.PLAYING) {
            const id = ev.target.getVideoData().video_id;
            mgr.stopOtherVideos(id);
        }
    };

    mgr.bindHandler = () => {
        for (const card of mgr.cards) {
            card.addEventListener('click', () => {
                const videoId = getVideoId(card);
                if (!videoId) return;

                const facade = card.querySelector('.gz-video-facade');
                if (facade) {
                    facade.classList.add('gz-video-facade--hidden');
                }

                mgr.loadVideo(videoId);
            }, false);
        }
    };

    mgr.init();

    const prevOnReady = window.onYouTubeIframeAPIReady;
    window.onYouTubeIframeAPIReady = () => {
        mgr.setLoaded();
        if (typeof prevOnReady === 'function') prevOnReady();
    };

    return mgr;
}